
// This file contains all the Arabic translations.
// Last updated: [DATE]
export default {
  translation: {
    landing: {
      nav: {
        features: 'المميزات',
        workflow: 'طريقة العمل',
        why_us: 'لماذا ريبلفاي',
        pricing: 'الباقات',
        login: 'دخول',
        get_started: 'جرب مجاناً'
      },
      hero: {
        new_feature: 'جديد: نظام الولاء الذكي',
        title_start: 'المنظومة المتكاملة',
        title_gradient: 'لإدارة المطاعم الحديثة',
        subtitle: 'تحكم في الطلبات، المخزون، الموظفين، والعملاء من منصة واحدة. صُممت لتمنحك السرعة، الدقة، والنمو المستمر.',
        start_trial: 'ابدأ تجربتك المجانية',
        view_demo: 'شاهد الفيديو التعريفي',
        no_card: 'بدون بطاقة ائتمان'
      },
      social_proof: {
        trusted_by: 'شريك النجاح لأكثر من 500 مطعم رائد'
      },
      core_features: {
        title: 'حلول متكاملة لمطعمك',
        subtitle: 'كل الأدوات التي تحتاجها لإدارة وتشغيل مطعمك بكفاءة عالية.',
        orders: 'إدارة الطلبات',
        inventory: 'المخزون والموارد',
        qr: 'قائمة QR ذكية',
        menu: 'تخصيص القائمة',
        branches: 'إدارة الفروع',
        analytics: 'التقارير والتحليلات',
        accounting: 'المحاسبة والمالية',
        users: 'فريق العمل',
        loyalty: 'برنامج الولاء'
      },
      sections: {
        orders: {
          title: 'نظام إدارة طلبات مركزي',
          desc: 'استقبل طلبات الصالة، التوصيل، والاستلام من شاشة واحدة. اربط الطلبات بالمطبخ مباشرة لضمان سرعة التحضير وتقليل الأخطاء.',
          feat1: 'ربط مباشر مع شاشات المطبخ (KDS)',
          feat2: 'متابعة حالة الطاولات لحظياً',
          feat3: 'خيارات مرنة للدفع وتقسيم الفواتير'
        },
        inventory: {
          title: 'تحكم دقيق في المخزون',
          desc: 'تجنب الهدر ونقص المواد. راقب مخزونك بدقة، واحصل على تنبيهات فورية عند انخفاض الكميات، مع حساب دقيق لتكلفة كل طبق.',
          feat1: 'حساب تكلفة الوصفات تلقائياً',
          feat2: 'إدارة الموردين والمشتريات',
          feat3: 'جرد وتحديث تلقائي للمخزون'
        },
        qr_menu: {
          title: 'قائمة طعام رقمية تفاعلية',
          desc: 'قدم لعملائك تجربة طلب عصرية عبر الباركود. عدل الأسعار والأصناف في ثوانٍ دون الحاجة لإعادة الطباعة.',
          feat1: 'واجهة متعددة اللغات',
          feat2: 'تحديث فوري للأسعار والصور',
          feat3: 'إمكانية الطلب والدفع من الطاولة'
        },
        multi_branch: {
          title: 'إدارة سلسلة فروعك بسهولة',
          desc: 'تابع أداء جميع فروعك من لوحة تحكم واحدة. وحد قوائم الطعام أو خصصها لكل فرع، وراقب المبيعات بشكل مركزي.',
          feat1: 'تقارير موحدة لجميع الفروع',
          feat2: 'تحكم مركزي في القوائم والأسعار',
          feat3: 'صلاحيات مخصصة لمدراء الفروع'
        },
        analytics: {
          title: 'رؤى وتحليلات لاتخاذ قرارات صائبة',
          desc: 'حول البيانات إلى أرباح. احصل على تقارير تفصيلية عن المبيعات، الأطباق الأكثر طلباً، وأداء الموظفين لتطوير عملك.',
          feat1: 'لوحة مؤشرات أداء تفاعلية',
          feat2: 'تحليل اتجاهات المبيعات والنمو',
          feat3: 'تقارير تفصيلية للورديات والمخزون'
        },
        accounting: {
          title: 'نظام محاسبي مبسط',
          desc: 'تابع تدفقاتك المالية بدقة. سجل المصروفات، راقب الأرباح والخسائر، واستخرج تقارير ضريبية جاهزة بضغطة زر.',
          feat1: 'تتبع دقيق للمصروفات والإيرادات',
          feat2: 'قوائم الدخل والأرباح',
          feat3: 'متوافق مع متطلبات الفوترة الإلكترونية'
        },
        users: {
          title: 'إدارة فريق العمل والصلاحيات',
          desc: 'نظم عمل موظفيك بكفاءة. حدد الصلاحيات لكل دور وظيفي، وراقب أداء كل موظف لضمان سير العمل بسلاسة.',
          feat1: 'صلاحيات مخصصة لكل موظف',
          feat2: 'سجل نشاط مفصل للعمليات',
          feat3: 'دخول آمن برمز PIN لكل مستخدم'
        },
        loyalty: {
          title: 'برنامج ولاء لزيادة مبيعاتك',
          desc: 'ابنِ علاقة قوية مع عملائك. كافئهم بنقاط على كل طلب وشجعهم على تكرار الزيارة لزيادة معدل الاحتفاظ بالعملاء.',
          feat1: 'نظام نقاط ومكافآت مرن',
          feat2: 'قاعدة بيانات لعملاء مطعمك',
          feat3: 'عروض ترويجية مخصصة'
        }
      },
      why_us: {
        title: 'لماذا يختار أصحاب المطاعم ريبلفاي؟',
        subtitle: 'لأننا صممنا النظام ليكون شريكك في النجاح، لا مجرد أداة.',
        benefit1: {
          title: 'كل ما تحتاجه في مكان واحد',
          desc: 'تخلص من تشتت الأنظمة المتعددة. ريبلفاي يجمع لك الكاشير، المخزون، والولاء في منصة واحدة.'
        },
        benefit2: {
          title: 'سهولة وسرعة في الاستخدام',
          desc: 'واجهة بديهية لا تحتاج لتدريب طويل، مصممة لتسريع الخدمة وتقليل أخطاء الموظفين.'
        },
        benefit3: {
          title: 'دعم فني معك دائماً',
          desc: 'فريق دعم متخصص جاهز لمساعدتك في أي وقت لضمان استمرار عمل مطعمك دون توقف.'
        },
      },
      workflow: {
        title: 'رحلة طلب سلسة ومتكاملة',
        subtitle: 'نظام يربط بين العميل، النادل، والمطبخ في تناغم تام.',
        step1: 'العميل يطلب عبر الـ QR أو النادل',
        step2: 'الطلب يصل فوراً لشاشة المطبخ',
        step3: 'تجهيز وتقديم الطلب بسرعة',
        step4: 'الدفع وكسب نقاط الولاء'
      },
      pricing: {
        title: 'باقات تناسب حجم مشروعك',
        subtitle: 'اختر الخطة المثالية لمطعمك، سواء كنت في البداية أو تتوسع.',
        starter: 'البداية',
        pro: 'النمو',
        enterprise: 'المؤسسات',
        currency: 'ر.س',
        month: '/شهر',
        cta: 'اشترك الآن'
      },
      cta: {
        title: 'جاهز لنقل مطعمك للمستوى التالي؟',
        subtitle: 'انضم لمئات المطاعم الناجحة التي تعتمد على ريبلفاي.',
        button: 'ابدأ فترتك التجريبية'
      },
      footer: {
        rights: 'جميع الحقوق محفوظة.'
      }
    },
    dashboard: {
      title: 'Ripplefy',
      navigation: {
        overview: 'نظرة عامة',
        business_profile: 'الملف التجاري',
        branches: 'الفروع',
        menu_management: 'إدارة القائمة',
        orders: 'الطلبات',
        pos_system: 'نظام نقاط البيع',
        staff_management: 'إدارة الموظفين',
        loyalty_program: 'برنامج الولاء',
        customization: 'التخصيص',
        menu_builder: 'منشئ القائمة',
        menu_designer: 'مصمم القائمة',
        analytics: 'التحليلات',
        advanced_analytics: 'التحليلات المتقدمة',
        feedback: 'التعليقات',
        audit_logs: 'سجل التغييرات',
        qr_codes: 'رموز QR',
        tables: 'الطاولات',
        kitchen: 'شاشة المطبخ',
        meta_pixel: 'بكسل ميتا',
        settings: 'الإعدادات',
        reservations: 'الحجوزات',
        waiting_list: 'قائمة الانتظار',
        delivery_management: 'إدارة التوصيل',
        inventory: 'المخزون',
        customer_communication: 'التواصل مع العملاء',
        marketing_promotions: 'التسويق والعروض',
        financial_reports: 'التقارير المالية',
        subscription: 'الاشتراك',
        sections: {
          overview: 'نظرة عامة',
          operations: 'العمليات',
          management: 'الإدارة',
          analytics: 'التحليلات والتقارير',
          customization: 'التخصيص والإعدادات'
        }
      },
      logout: 'تسجيل الخروج',
      language: 'اللغة',
      overview: {
        title: 'نظرة عامة على لوحة التحكم',
        subtitle: 'مرحبًا بك في منصة إدارة مطعمك',
        welcome_back: 'أهلاً بعودتك، {{name}}!',
        welcome: 'مرحبًا بك في منصة إدارة مطعمك',
        stat_cards: {
          restaurant: 'مطعم',
          restaurant_desc: 'لم يتم إعداد أي مطعم',
          total_branches: 'إجمالي الفروع',
          total_branches_desc: 'المواقع النشطة',
          menu_items: 'عناصر القائمة',
          menu_items_desc: 'عبر جميع الفروع',
          qr_code_scans: 'مسح رمز الاستجابة السريعة',
          qr_code_scans_desc: 'هذا الشهر',
        },
        quick_actions: {
          title: 'إجراءات سريعة',
          desc_manage: 'إدارة مطعمك وفروعك',
          desc_get_started: 'ابدأ مع مطعمك',
          manage_restaurant: 'إدارة المطعم',
          menu_management: 'إدارة القائمة',
          customize_menu: 'تخصيص القائمة',
          setup_needed: 'تحتاج إلى إكمال إعداد المطعم أولاً.',
          complete_setup: 'إكمال الإعداد'
        },
        recent_activity: {
          title: 'النشاط الأخير',
          no_activity: 'لا يوجد نشاط حديث',
          activity_appears_here: 'سيظهر النشاط هنا',
          complete_setup_to_see_activity: 'أكمل الإعداد لرؤية النشاط'
        },
      },
      home: {
        staff_dashboard: 'لوحة تحكم الموظف',
        take_a_tour: 'جولة تعريفية',
        total_branches: 'إجمالي الفروع',
        active_locations: 'الفروع النشطة',
        pending_orders: 'الطلبات المعلقة',
        awaiting_processing: 'بانتظار المعالجة',
        action_needed: 'يحتاج إجراء',
        total_orders: 'إجمالي الطلبات',
        all_time_orders: 'جميع الطلبات',
        core_operations: 'العمليات الأساسية',
        core_operations_desc: 'وصول سريع لعمليات الإدارة اليومية',
        advanced_features: 'الميزات المتقدمة',
        get_started: 'ابدأ الآن',
        complete_setup_unlock: 'أكمل الإعداد لفتح جميع الميزات',
        business_profile: 'الملف التجاري',
        create_branch: 'إنشاء فرع',
        setup_menu: 'إعداد القائمة',
        manage_orders: 'إدارة الطلبات',
        track_fulfill_orders: 'تتبع وتنفيذ الطلبات',
        update_menu_items: 'تحديث عناصر القائمة',
        qr_codes: 'أكواد QR',
        generate_qr_codes: 'إنشاء أكواد QR للطاولات',
        loyalty_program: 'برنامج الولاء',
        customer_rewards: 'مكافآت العملاء',
        advanced_analytics: 'التحليلات المتقدمة',
        detailed_insights: 'رؤى تفصيلية',
        customize_menu: 'تخصيص القائمة',
        branding_layout: 'العلامة التجارية والتصميم'
      },
      business_profile: {
        title: 'الملف التجاري',
        description: 'إدارة تفاصيل وفروع مطعمك.',
        edit_branch_dialog: {
          title: 'تعديل الفرع',
          description: 'تحديث معلومات وإعدادات الفرع',
          restaurant_name_label: 'اسم المطعم',
          restaurant_name_placeholder: 'أدخل اسم المطعم',
          restaurant_description_label: 'وصف المطعم',
          restaurant_description_placeholder: 'أدخل وصفاً لمطعمك',
          branch_name_label: 'اسم الفرع',
          branch_name_placeholder: 'أدخل اسم الفرع',
          slug_label: 'رابط URL',
          slug_description: 'سيتم استخدام هذا في رابط القائمة الخاصة بك',
          address_label: 'العنوان',
          address_placeholder: 'أدخل عنوان الفرع',
          phone_label: 'رقم الهاتف',
          phone_placeholder: 'أدخل رقم الهاتف',
          whatsapp_label: 'واتساب',
          whatsapp_placeholder: 'أدخل رقم الواتساب',
          instagram_label: 'انستغرام',
          instagram_placeholder: 'أدخل حساب الانستغرام',
          facebook_label: 'فيسبوك',
          facebook_placeholder: 'أدخل رابط صفحة الفيسبوك',
          website_label: 'الموقع الإلكتروني',
          website_placeholder: 'أدخل رابط الموقع الإلكتروني',
          save_button: 'حفظ التغييرات',
          cancel_button: 'إلغاء',
          toast_success_title: 'نجاح',
          toast_success_description: 'تم تحديث الفرع بنجاح',
          toast_error_title: 'خطأ',
          toast_error_description: 'فشل تحديث الفرع',
          toast_error_slug_taken: 'رابط URL هذا مستخدم بالفعل',
          toast_error_failed: 'حدث خطأ أثناء تحديث الفرع'
        },
        create_branch_dialog: {
          title: 'إنشاء فرع جديد',
          name_label: 'اسم الفرع',
          name_placeholder: 'أدخل اسم الفرع',
          address_label: 'العنوان',
          address_placeholder: 'أدخل عنوان الفرع',
          phone_label: 'رقم الهاتف',
          phone_placeholder: 'أدخل رقم الهاتف',
          whatsapp_label: 'واتساب',
          instagram_label: 'انستغرام',
          instagram_placeholder: 'أدخل حساب الانستغرام',
          facebook_label: 'فيسبوك',
          facebook_placeholder: 'أدخل رابط صفحة الفيسبوك',
          website_label: 'الموقع الإلكتروني',
          website_placeholder: 'أدخل رابط الموقع الإلكتروني',
          cancel_button: 'إلغاء',
          create_button: 'إنشاء الفرع',
          creating_button: 'جار الإنشاء...',
          toast_success_title: 'نجاح',
          toast_success_description: 'تم إنشاء الفرع بنجاح',
          toast_error_title: 'خطأ',
          toast_error_name_required: 'اسم الفرع مطلوب',
          toast_error_failed: 'فشل في إنشاء الفرع'
        },
        restaurant_info: {
          title: 'معلومات المطعم',
          description: 'إدارة المعلومات الأساسية والعلامة التجارية لمطعمك.',
          edit_button: 'تعديل',
          name_label: 'اسم المطعم *',
          phone_label: 'رقم الهاتف',
          description_label: 'الوصف',
          logo_label: 'شعار المطعم',
          save_button: 'حفظ التغييرات',
          saving_button: 'جار الحفظ...',
          cancel_button: 'إلغاء',
          no_description: 'لم يتم تقديم أي وصف.'
        },
        branches: {
          title: 'مواقع الفروع',
          description: 'إدارة مواقع مطعمك وإعداداتها الفردية.',
          add_button: 'إضافة فرع',
          no_branches: 'لم تتم إضافة أي فروع بعد.',
          view_live_button: 'عرض مباشر'
        },
        toasts: {
          success_title: 'نجاح',
          success_description: 'تم تحديث ملف المطعم بنجاح!',
          error_title: 'خطأ',
          error_description: 'فشل تحديث ملف المطعم',
          branch_created_success: 'تم إنشاء الفرع بنجاح!'
        },
        no_restaurant: 'لم يتم العثور على مطعم. يرجى إكمال عملية الإعداد.',
        branches_page: {
          title: 'إدارة الفروع',
          description: 'إدارة جميع مواقع مطعمك من مكان واحد.',
          add_button: 'إضافة فرع جديد',
          all_branches: 'كل الفروع ({{count}})',
          all_branches_desc: 'قائمة بجميع فروع مطعمك.',
          no_branches_title: 'لا توجد فروع بعد',
          no_branches_desc: 'انقر فوق "إضافة فرع جديد" لإنشاء موقعك الأول.',
          active: 'نشط',
          inactive: 'غير نشط',
          open_menu: 'فتح القائمة',
          edit_button: 'تعديل',
          view_live_menu: 'عرض القائمة المباشرة'
        },
      },
      inventory: {
        title: 'إدارة المخزون',
        description: 'إدارة المواد الخام، تتبع مستويات المخزون، وتحليل التكاليف.',
        tabs: {
          overview: 'نظرة عامة',
          materials: 'المواد',
          recipes: 'الوصفات',
          analytics: 'التحليلات',
          expenses: 'المصروفات'
        },
        alerts: {
          stock_alerts_message: 'لديك تنبيهات مخزون تحتاج إلى اهتمام',
          out_of_stock: 'نفذ المخزون',
          low_stock: 'مخزون منخفض',
          view_materials: 'عرض المواد'
        },
        empty_states: {
          select_branch: 'اختر فرعاً',
          select_branch_desc: 'اختر فرعاً لعرض بيانات المخزون',
          materials_desc: 'اختر فرعاً لإدارة المواد',
          recipes_desc: 'اختر فرعاً لإدارة الوصفات',
          analytics_desc: 'اختر فرعاً لعرض التحليلات',
          expenses_desc: 'اختر فرعاً لإدارة المصروفات'
        },

        dashboard: {
          beta_label: 'تجريبي',
          currently_viewing: 'عرض حالي',
          select_branch: 'اختر الفرع',
          select_branch_prompt: 'الرجاء اختيار فرع لعرض بيانات المخزون',
          no_branches: 'لا توجد فروع متاحة. الرجاء إنشاء فرع أولاً.',
          roadmap: {
            title: 'خريطة طريق إدارة المخزون',
            description: 'شاهد الميزات المتاحة وما هو قادم قريباً',
            available_now: 'متاح الآن',
            coming_soon: 'قريباً',
            future: 'خطط مستقبلية',
            features: {
              materials: 'إدارة المواد',
              recipes: 'إنشاء وإدارة الوصفات',
              analytics: 'تحليلات ورؤى متقدمة',
              expenses: 'تتبع المصروفات',
              cost_tracking: 'تتبع وتحليل التكاليف',
              waste_analysis: 'تحليل الهدر والتوصيات',
              purchase_orders: 'إدارة أوامر الشراء',
              suppliers: 'إدارة الموردين',
              barcode: 'مسح الباركود',
              notifications: 'تنبيهات وإشعارات المخزون',
              mobile_app: 'تطبيق المخزون للجوال',
              ai_forecasting: 'التنبؤ بالطلب بالذكاء الاصطناعي',
              pos_integration: 'التكامل مع نظام نقاط البيع',
              realtime_tracking: 'تتبع المخزون في الوقت الفعلي'
            }
          }
        },
        dashboard_old: {
          title: 'لوحة التحكم',
          quick_stats: {
            total_materials: 'إجمالي المواد',
            total_value: 'القيمة الإجمالية',
            low_stock: 'مخزون منخفض',
            out_of_stock: 'نفذ المخزون',
            average_cost: 'متوسط التكلفة',
            monthly_spending: 'الإنفاق الشهري',
            monthly_savings: 'التوفير الشهري',
            stock_turnover: 'معدل دوران المخزون'
          },
          roadmap: {
            title: 'الخريطة الطريقية',
            analytics_available: 'التحليلات والتقارير - متاحة الآن',
            analytics_desc: 'تحليلات شاملة، تقارير مفصلة، وتحليل التكاليف',
            purchase_orders: 'أوامر الشراء - قريباً',
            purchase_orders_desc: 'إدارة أوامر الشراء الآلية وتكامل الموردين',
            supplier_management: 'إدارة الموردين - قريباً',
            supplier_management_desc: 'إدارة الموردين، تتبع التسليم، والتفاوض على الأسعار'
          }
        },
        analytics: {
          title: 'تحليلات المخزون',
          description: 'تحليلات ورؤى شاملة للمخزون',
          no_branch_selected: 'الرجاء تحديد فرع لعرض التحليلات',
          time_range: {
            label: 'الفترة الزمنية',
            last_7_days: 'آخر 7 أيام',
            last_30_days: 'آخر 30 يوم',
            last_90_days: 'آخر 90 يوم',
            last_6_months: 'آخر 6 أشهر',
            last_year: 'آخر سنة'
          },
          tabs: {
            overview: 'نظرة عامة',
            financial: 'المالية',
            waste: 'الهدر',
            usage: 'الاستخدام',
            recipes: 'الوصفات'
          },
          metrics: {
            revenue: 'الإيرادات',
            cogs: 'تكلفة البضاعة المباعة',
            of_revenue: 'من الإيرادات',
            net_profit: 'صافي الربح',
            margin: 'هامش',
            inventory_value: 'قيمة المخزون',
            materials: 'مادة',
            stock_turnover: 'معدل دوران المخزون',
            stock_turnover_desc: 'عدد مرات بيع المخزون في الفترة',
            waste_percentage: 'نسبة الهدر',
            total_waste: 'إجمالي الهدر',
            stock_alerts: 'تنبيهات المخزون',
            out_of_stock: 'نفذ المخزون',
            low_stock: 'مخزون منخفض',
            total_value: 'القيمة الإجمالية',
            total_materials: 'إجمالي المواد',
            monthly_spending: 'الإنفاق الشهري',
            stock_turnover_rate: 'معدل دوران المخزون',
            low_stock_count: 'المواد منخفضة المخزون',
            out_of_stock_count: 'نفذ المخزون'
          },
          charts: {
            top_used_materials: 'المواد الأكثر استخداماً',
            top_used_materials_desc: 'المواد ذات الاستهلاك الأعلى في هذه الفترة',
            top_materials_by_value: 'أفضل المواد حسب القيمة',
            stock_levels: 'مستويات المخزون',
            transaction_history: 'تاريخ المعاملات'
          },
          alerts: {
            stock_alerts_title: 'تنبيهات المخزون',
            items: 'عناصر'
          },
          financial: {
            revenue_breakdown: 'تفصيل الإيرادات',
            total_revenue: 'إجمالي الإيرادات',
            cogs: 'تكلفة البضاعة المباعة',
            gross_profit: 'إجمالي الربح',
            expenses: 'المصروفات التشغيلية',
            net_profit: 'صافي الربح',
            profit_margins: 'هوامش الربح',
            gross_margin: 'هامش الربح الإجمالي',
            gross_margin_desc: 'الإيرادات ناقص تكلفة البضاعة المباعة',
            net_margin: 'هامش الربح الصافي',
            net_margin_desc: 'الربح بعد جميع المصروفات',
            cogs_ratio: 'نسبة تكلفة الطعام',
            cogs_ratio_desc: 'النسبة المئوية لتكلفة الطعام'
          },
          waste: {
            total_waste: 'إجمالي الهدر',
            total_units: 'وحدات مهدرة',
            waste_cost: 'تكلفة الهدر',
            of_purchases: 'من المشتريات',
            significant_waste_items: 'الهدر الكبير',
            items_over_threshold: 'عناصر فوق الحد',
            high_waste_materials: 'المواد عالية الهدر',
            high_waste_desc: 'المواد ذات الهدر الكبير التي تحتاج اهتماماً',
            waste_rate: 'معدل الهدر',
            recommendations: 'توصيات تقليل الهدر'
          },
          usage: {
            material_consumption: 'استهلاك المواد',
            material_consumption_desc: 'تتبع أنماط الاستخدام والتنبؤ باحتياجات إعادة التخزين',
            used: 'مستخدم',
            current_stock: 'الحالي',
            daily_avg: 'المتوسط اليومي',
            days_left: 'أيام متبقية',
            well_stocked: 'مخزون جيد',
            no_data: 'لا توجد بيانات استخدام متاحة',
            no_data_desc: 'ابدأ في تتبع المواد وتسجيل المعاملات لرؤية تحليلات الاستخدام'
          },
          recipes: {
            cost_analysis: 'تحليل تكلفة الوصفات',
            cost_analysis_desc: 'تحليل الربحية والتكاليف لكل وصفة',
            ingredients: 'مكونات',
            margin: 'هامش',
            cost_per_serving: 'التكلفة/حصة',
            selling_price: 'السعر',
            yield: 'الناتج',
            no_data: 'لم يتم العثور على وصفات',
            no_data_desc: 'قم بإنشاء وصفات في علامة تبويب الوصفات لتحليل تكاليفها وربحيتها'
          },
          insights: {
            healthy_gross_margin: 'هامش ربح إجمالي قوي أعلى من 50%',
            good_stock_turnover: 'معدل دوران مخزون صحي أعلى من 4 مرات في الفترة',
            profitable_period: 'صافي الربح إيجابي في هذه الفترة',
            high_cogs: 'نسبة تكلفة البضاعة المباعة عالية - فكر في تحسين الوصفات',
            high_waste: 'الهدر يتجاوز 5% - راجع ممارسات المخزون',
            many_low_stock: 'عدة عناصر منخفضة المخزون - راجع نقاط إعادة الطلب'
          },
          key_insights: {
            title: 'الرؤى الرئيسية',
            positive_indicators: 'المؤشرات الإيجابية',
            areas_for_improvement: 'مجالات التحسين'
          },
          transaction_types: {
            purchases: 'المشتريات',
            sales: 'المبيعات',
            adjustments: 'التعديلات'
          },
          export_button: 'تصدير البيانات'
        },

        costs: {
          title: 'تحليل التكاليف',
          description: 'تحليل مفصل للتكاليف ورؤى التحسين',
          metrics: {
            total_inventory_value: 'إجمالي قيمة المخزون',
            average_cost_per_item: 'متوسط التكلفة لكل عنصر',
            monthly_spending: 'الإنفاق الشهري',
            cost_variance: 'تباين التكلفة'
          },
          analysis: {
            top_expensive_items: 'أغلى العناصر',
            cost_distribution: 'توزيع التكاليف',
            cost_trends: 'اتجاهات التكلفة',
            cost_efficiency: 'كفاءة التكلفة'
          },
          charts: {
            cost_trends: 'اتجاهات التكلفة (آخر 6 أشهر)',
            supplier_analysis: 'تحليل تكلفة الموردين'
          },
          labels: {
            total_cost: 'التكلفة الإجمالية',
            avg_cost: 'متوسط التكلفة',
            items: 'العناصر',
            avg: 'المتوسط'
          },
          no_data: 'لا توجد بيانات تكلفة متاحة',
          cost_efficiency_insights: {
            title: 'رؤى كفاءة التكلفة',
            cost_optimization: 'تحسين التكلفة',
            cost_concerns: 'مخاوف التكلفة',
            low_cost_items: 'عناصر منخفضة التكلفة (قيمة جيدة)',
            medium_cost_items: 'عناصر متوسطة التكلفة (متوازنة)',
            high_cost_items: 'عناصر عالية التكلفة تحتاج مراجعة',
            monthly_spending: 'الإنفاق الشهري',
            cost_variance: 'تباين التكلفة',
            average_cost_per_item: 'متوسط التكلفة لكل عنصر'
          }
        },
        advanced_analytics: {
          title: 'التحليلات المتقدمة',
          description: 'رؤى عميقة في تكاليف القائمة وكفاءة الإنتاج وأداء الأعمال',
          metrics: {
            total_revenue: 'إجمالي الإيرادات',
            total_profit: 'إجمالي الربح',
            overall_efficiency: 'الكفاءة الإجمالية',
            staff_efficiency: 'كفاءة الموظفين'
          },
          tabs: {
            menu_costs: 'تكاليف القائمة',
            production: 'الإنتاج',
            staff: 'الموظفين',
            materials: 'المواد',
            waste: 'هدر المواد',
            variance: 'تباين التكلفة'
          },
          tables: {
            menu_item_cost_analysis: 'تحليل تكلفة عناصر القائمة',
            production_efficiency_analysis: 'تحليل كفاءة الإنتاج',
            staff_performance_analysis: 'تحليل أداء الموظفين',
            material_usage_analysis: 'تحليل استخدام المواد',
            cost_variance_analysis: 'تحليل تباين التكلفة'
          },
          columns: {
            item: 'العنصر',
            base_price: 'السعر الأساسي',
            cost: 'التكلفة',
            profit_margin: 'هامش الربح',
            sales: 'المبيعات',
            revenue: 'الإيرادات',
            efficiency: 'الكفاءة',
            expected: 'المتوقع',
            actual: 'الفعلي',
            waste: 'الهدر',
            cost_variance: 'تباين التكلفة',
            staff_performance: 'أداء الموظفين',
            staff_member: 'الموظف',
            items_produced: 'العناصر المنتجة',
            waste_percentage: 'نسبة الهدر %',
            quality_score: 'درجة الجودة',
            material: 'المادة',
            variance: 'التباين',
            cost_impact: 'تأثير التكلفة',
            trend: 'الاتجاه',
            recipe: 'الوصفة',
            ingredients: 'المكونات',
            labor: 'العمالة',
            overhead: 'النفقات العامة',
            total_cost: 'التكلفة الإجمالية',
            selling_price: 'سعر البيع'
          },
          cost_variance_analysis: {
            title: 'تحليل تباين التكلفة',
            expected_cost: 'التكلفة المتوقعة',
            actual_cost: 'التكلفة الفعلية',
            variance: 'التباين',
            top_variance_items: 'أعلى عناصر التباين',
            efficiency_insights: 'رؤى الكفاءة'
          },
          no_data: 'لا توجد بيانات تحليل متاحة'
        },

        recipe_costs: {
          title: 'حاسبة تكلفة الوصفات',
          description: 'تحليل تكاليف الوصفات وهوامش الربح وفرص التحسين',
          metrics: {
            total_recipes: 'إجمالي الوصفات',
            average_cost: 'متوسط التكلفة',
            average_profit_margin: 'متوسط هامش الربح',
            total_profit_potential: 'إجمالي إمكانية الربح'
          },
          tables: {
            recipe_cost_analysis: 'تحليل تكلفة الوصفات',
            top_profitable_recipes: 'أفضل الوصفات ربحية',
            cost_optimization_opportunities: 'فرص تحسين التكلفة'
          },
          columns: {
            recipe: 'الوصفة',
            ingredients: 'المكونات',
            labor: 'العمالة',
            overhead: 'النفقات العامة',
            total_cost: 'التكلفة الإجمالية',
            selling_price: 'سعر البيع',
            profit_margin: 'هامش الربح',
            efficiency: 'الكفاءة',
            trend: 'الاتجاه'
          },
          no_data: 'لا توجد بيانات تكلفة وصفات متاحة'
        },
        business_insights: {
          title: 'لوحة رؤى الأعمال',
          description: 'رؤى قابلة للتنفيذ لتحسين أداء وربحية مطعمك',
          metrics: {
            overall_efficiency: 'الكفاءة الإجمالية',
            staff_efficiency: 'كفاءة الموظفين',
            items_needing_attention: 'العناصر التي تحتاج اهتمام',
            cost_savings_potential: 'إمكانية توفير التكلفة'
          },
          tables: {
            production_efficiency_analysis: 'تحليل كفاءة الإنتاج',
            material_usage_patterns: 'أنماط استخدام المواد والمقارنة الأسبوعية',
            cost_trends_analysis: 'تحليل اتجاهات التكلفة'
          },
          columns: {
            menu_item: 'عنصر القائمة',
            expected: 'المتوقع',
            actual: 'الفعلي',
            efficiency: 'الكفاءة',
            waste: 'الهدر',
            cost_variance: 'تباين التكلفة',
            trend: 'الاتجاه',
            material: 'المادة',
            variance: 'التباين',
            cost_impact: 'تأثير التكلفة',
            this_week: 'هذا الأسبوع',
            last_week: 'الأسبوع الماضي',
            change: 'التغيير'
          },
          action_required: 'إجراء مطلوب',
          cost_trend_analysis: 'تحليل اتجاه التكلفة',
          no_data: 'لا توجد بيانات رؤى أعمال متاحة'
        },
        reports: {
          title: 'التقارير',
          description: 'تقارير وتحليل مفصلة للمخزون',
          filters: {
            search: 'البحث في المواد...',
            stock_status: 'حالة المخزون',
            all_statuses: 'جميع الحالات',
            in_stock: 'متوفر في المخزون',
            low_stock: 'مخزون منخفض',
            out_of_stock: 'نفذ المخزون',
            supplier: 'المورد',
            all_suppliers: 'جميع الموردين',
            date_range: 'نطاق التاريخ',
            transaction_type: 'نوع المعاملة',
            all_types: 'جميع الأنواع',
            purchase: 'شراء',
            sale: 'بيع',
            adjustment: 'تعديل'
          },
          summary: {
            materials_count: 'عدد المواد',
            total_value: 'القيمة الإجمالية',
            low_stock_count: 'مخزون منخفض',
            out_of_stock_count: 'نفذ المخزون'
          },
          tabs: {
            materials: 'المواد',
            transactions: 'المعاملات'
          },
          columns: {
            material: 'المادة',
            stock_level: 'مستوى المخزون',
            status: 'الحالة',
            cost_per_unit: 'التكلفة/الوحدة',
            total_value: 'القيمة الإجمالية',
            supplier: 'المورد',
            transactions: 'المعاملات',
            last_activity: 'آخر نشاط',
            type: 'النوع',
            quantity: 'الكمية',
            total_cost: 'التكلفة الإجمالية',
            date: 'التاريخ'
          },
          export_button: 'تصدير إلى CSV',
          no_data: 'لا توجد بيانات تقرير متاحة'
        },

        materials: {
          title: 'المواد',
          description: 'إدارة المواد الخام وتتبع مستويات المخزون',
          add_material: 'إضافة مادة',
          edit_material: 'تعديل المادة',
          delete_material: 'حذف المادة',
          material_name: 'اسم المادة',
          material_name_placeholder: 'أدخل اسم المادة',
          material_description: 'الوصف',
          material_description_placeholder: 'أدخل وصف المادة',
          category: 'الفئة',
          category_placeholder: 'اختر الفئة',
          unit: 'الوحدة',
          unit_placeholder: 'اختر الوحدة',
          current_stock: 'المخزون الحالي',
          current_stock_placeholder: 'أدخل المخزون الحالي',
          minimum_stock: 'الحد الأدنى للمخزون',
          minimum_stock_placeholder: 'أدخل الحد الأدنى لمستوى المخزون',
          cost_per_unit: 'التكلفة لكل وحدة',
          cost_per_unit_placeholder: 'أدخل التكلفة لكل وحدة',
          supplier: 'المورد',
          supplier_placeholder: 'أدخل اسم المورد',
          location: 'الموقع',
          location_placeholder: 'أدخل موقع التخزين',
          save_button: 'حفظ المادة',
          saving_button: 'جار الحفظ...',
          cancel_button: 'إلغاء',
          delete_confirm_title: 'حذف المادة',
          delete_confirm_desc: 'هل أنت متأكد أنك تريد حذف "{{name}}؟" لا يمكن التراجع عن هذا الإجراء.',
          toasts: {
            success_title: 'نجاح',
            success_desc: 'تم حفظ المادة بنجاح',
            error_title: 'خطأ',
            error_desc: 'فشل في حفظ المادة',
            delete_success_title: 'نجاح',
            delete_success_desc: 'تم حذف المادة بنجاح',
            delete_error_title: 'خطأ',
            delete_error_desc: 'فشل في حذف المادة'
          }
        },
        recipes: {
          title: 'الوصفات',
          description: 'إدارة الوصفات ومتطلبات المكونات',
          add_recipe: 'إضافة وصفة',
          edit_recipe: 'تعديل الوصفة',
          delete_recipe: 'حذف الوصفة',
          recipe_name: 'اسم الوصفة',
          recipe_name_placeholder: 'أدخل اسم الوصفة',
          recipe_description: 'الوصف',
          recipe_description_placeholder: 'أدخل وصف الوصفة',
          ingredients: 'المكونات',
          add_ingredient: 'إضافة مكون',
          ingredient: 'المكون',
          ingredient_placeholder: 'اختر المكون',
          quantity: 'الكمية',
          quantity_placeholder: 'أدخل الكمية',
          unit: 'الوحدة',
          unit_placeholder: 'اختر الوحدة',
          save_button: 'حفظ الوصفة',
          saving_button: 'جار الحفظ...',
          cancel_button: 'إلغاء',
          delete_confirm_title: 'حذف الوصفة',
          delete_confirm_desc: 'هل أنت متأكد أنك تريد حذف "{{name}}؟" لا يمكن التراجع عن هذا الإجراء.',
          toasts: {
            success_title: 'نجاح',
            success_desc: 'تم حفظ الوصفة بنجاح',
            error_title: 'خطأ',
            error_desc: 'فشل في حفظ الوصفة',
            delete_success_title: 'نجاح',
            delete_success_desc: 'تم حذف الوصفة بنجاح',
            delete_error_title: 'خطأ',
            delete_error_desc: 'فشل في حذف الوصفة'
          }
        },
        settings: {
          title: 'الإعدادات',
          description: 'تكوين إعدادات إدارة المخزون',
          general_settings: 'الإعدادات العامة',
          notifications: 'الإشعارات',
          low_stock_alert: 'تنبيه المخزون المنخفض',
          low_stock_alert_desc: 'احصل على إشعار عندما تصل العناصر إلى الحد الأدنى لمستوى المخزون',
          out_of_stock_alert: 'تنبيه نفاد المخزون',
          out_of_stock_alert_desc: 'احصل على إشعار عندما تنفد العناصر من المخزون',
          cost_tracking: 'تتبع التكاليف',
          cost_tracking_desc: 'تتبع التكاليف وحساب هوامش الربح',
          save_button: 'حفظ الإعدادات',
          saving_button: 'جار الحفظ...',
          toasts: {
            success_title: 'نجاح',
            success_desc: 'تم حفظ الإعدادات بنجاح',
            error_title: 'خطأ',
            error_desc: 'فشل في حفظ الإعدادات'
          }
        }
      },
      menu_management: {
        title: 'إدارة القائمة',
        description: 'تنظيم عناصر القائمة والفئات لكل فرع.',
        new_category_button: 'فئة جديدة',
        select_branch_prompt_title: 'اختر فرعًا للبدء',
        select_branch_prompt_desc: 'اختر فرعًا من القائمة المنسدلة أعلاه لإدارة قائمته.',
        no_categories_title: 'لا توجد فئات بعد',
        no_categories_desc: 'أنشئ فئتك الأولى أو قم بتحميل قائمة للبدء.',
        create_first_category_button: 'إنشاء الفئة الأولى',
        active_badge: 'نشط',
        inactive_badge: 'غير نشط',
        add_item_button: 'إضافة عنصر',
        open_menu: 'فتح القائمة',
        edit_category_button: 'تعديل الفئة',
        delete_category_button: 'حذف الفئة',
        edit_item_button: 'تعديل العنصر',
        delete_item_button: 'حذف العنصر',
        available_label: 'متوفر',
        availability_enabled: 'تم تفعيله بنجاح',
        availability_disabled: 'تم إلغاء تفعيله بنجاح',
        availability_update_error: 'فشل في تحديث حالة توفر العنصر',
        delete_category_title: 'حذف الفئة',
        delete_category_desc: 'هل أنت متأكد أنك تريد حذف "{{name}}؟" لا يمكن التراجع عن هذا الإجراء.',
        delete_menu_item_title: 'حذف عنصر القائمة',
        delete_menu_item_desc: 'هل أنت متأكد أنك تريد حذف "{{name}}؟" لا يمكن التراجع عن هذا الإجراء.',
        toasts: {
          update_order_error_title: 'خطأ',
          update_order_error_desc: 'تعذر حفظ الترتيب الجديد. يرجى المحاولة مرة أخرى.',
          update_order_success_title: 'نجاح!',
          update_order_success_desc: 'تم حفظ الترتيب الجديد.',
          delete_success_title: 'نجاح!',
          delete_success_desc: 'تم حذف {{type}}.',
          delete_error_title: 'خطأ',
          delete_error_desc: 'فشل الحذف. يرجى المحاولة مرة أخرى.'
        },
        menu_upload_component: {
          title: "تحميل قائمتك",
          description: "قم بتحميل صورة أو ملف PDF لقائمتك الحالية، وسنقوم تلقائيًا باستخراج الفئات والعناصر والأسعار لبناء قائمتك الرقمية.",
          uploading_and_processing: 'جار التحميل والمعالجة...',
          drop_here: 'أفلت ملف قائمتك هنا',
          click_to_upload: 'انقر للتحميل',
          drag_and_drop: 'أو اسحب وأفلت',
          supported_files: 'يدعم صور JPG, PNG, WebP و ملفات PDF',
          recent_uploads_title: 'التحميلات الأخيرة',
          recent_uploads_description: 'عرض وإدارة سجل تحميل قائمتك',
          status: {
            processing: 'قيد المعالجة',
            completed: 'مكتمل',
            failed: 'فشل',
            unknown: 'غير معروف'
          },
          preview_button: 'معاينة',
          view_file_button: 'عرض',
          delete_dialog_title: 'حذف تحميل القائمة',
          delete_dialog_description: 'هل أنت متأكد أنك تريد حذف "{{fileName}}؟" لا يمكن التراجع عن هذا الإجراء.',
          cancel_button: 'إلغاء',
          delete_button: 'حذف',
          delete_error_toast: 'فشل حذف التحميل. يرجى المحاولة مرة أخرى.'
        },
        complete_setup_to_see_activity: 'أكمل الإعداد لرؤية النشاط'
      },
      menu_item: {
        available: 'متوفر',
        unavailable: 'غير متوفر',
        choose_size: 'اختر الحجم',
        select_variant_first: 'اختر الحجم أولاً',
        regular: 'عادي',
        add_to_cart: 'أضف للسلة'
      },
      rating: {
        rate_this_item: 'قيم هذا العنصر',
        loading: 'جار التحميل...',
        no_ratings_yet: 'لا توجد تقييمات بعد',
        no_reviews_yet: 'لا توجد مراجعات بعد',
        rating_required: 'التقييم مطلوب',
        please_select_rating: 'يرجى اختيار تقييم قبل الإرسال.',
        your_rating: 'تقييمك',
        your_name_optional: 'اسمك (اختياري)',
        comment_optional: 'تعليق (اختياري)',
        submit_rating: 'إرسال التقييم',
        submitting: 'جار الإرسال...',
        thank_you: 'شكرًا لك!',
        rating_submitted_success: 'تم إرسال تقييمك بنجاح.',
        error: 'خطأ',
        submit_failed: 'فشل في إرسال التقييم. يرجى المحاولة مرة أخرى.',
        already_rated: 'تم التقييم بالفعل',
        already_rated_message: 'لقد قمت بتقييم هذا العنصر بالفعل',
        rate_item: 'قيم {{itemName}}',
        rating_dialog_description: 'شارك تجربتك مع هذا العنصر لمساعدة العملاء الآخرين.',
        name_placeholder: 'أدخل اسمك',
        comment_placeholder: 'أخبرنا عن تجربتك مع هذا العنصر...',
        review_singular: 'مراجعة',
        reviews_plural: 'مراجعات'
      },
      pop_offer: {
        title: "عرض منبثق",
        description: "إنشاء أو إدارة عرض ترويجي منبثق لقائمتك.",
        status: {
          no_offer: "لا يوجد عرض",
          expired: "منتهي الصلاحية",
          scheduled: "مجدول",
          active: "نشط",
        },
        image_label: "صورة العرض",
        description_label: "الوصف",
        description_placeholder: "مثال: 'احصل على خصم 20٪ على جميع أنواع البيتزا!'",
        start_time_label: "وقت البدء",
        end_time_label: "وقت الانتهاء",
        save_button: "حفظ العرض",
        saving_button: "جار الحفظ...",
        delete_button: "حذف العرض",
        deleting_button: "جار الحذف...",
        view_history_button: "عرض سجل العروض",
        archived_offers_title: "العروض المؤرشفة",
        archived_offers_description: "سجل بجميع العروض الترويجية السابقة لهذا الفرع.",
        loading_history: "جار تحميل السجل...",
        no_archived_offers: "لم يتم العثور على عروض مؤرشفة.",
        ran_from: "بدأ من",
        to: "إلى",
        archived_on: "أرشف في",
        toasts: {
          save_success_title: "نجاح",
          save_success_description: "تم حفظ العرض الترويجي بنجاح.",
          save_error_title: "خطأ",
          save_error_description: "فشل حفظ العرض الترويجي.",
          delete_success_title: "نجاح",
          delete_success_description: "تم حذف العرض الترويجي بنجاح.",
          delete_error_title: "خطأ",
          delete_error_description: "فشل حذف العرض الترويجي."
        },
        delete_confirm: "هل أنت متأكد أنك تريد حذف هذا العرض؟"
      },
      menu: {
        title: 'القائمة',
        unavailable: 'غير متوفر',
        item_unavailable_message: 'هذا الصنف غير متوفر حالياً'
      },
      menuManagement: {
        uploadSuccess: 'تم الرفع بنجاح',
        pdfUploadedAsReference: 'تم رفع ملف PDF كمرجع. استخراج القائمة بالذكاء الاصطناعي متاح للصور فقط.',
        processingMenu: 'جاري معالجة القائمة. قد يستغرق ذلك بضع لحظات.'
      },
      staff_order_manager: {
        title: "مدير طلبات الموظفين",
        description: "إنشاء وإدارة الطلبات يدوياً للعملاء في المتجر",
        menu_items: "عناصر القائمة",
        search_placeholder: "البحث في عناصر القائمة...",
        current_order: "الطلب الحالي",
        order_type: "نوع الطلب",
        customer_info: "معلومات العميل",
        payment_method: "طريقة الدفع",
        order_summary: "ملخص الطلب",
        create_order: "إنشاء طلب",
        clear_cart: "مسح السلة",
        add_to_order: "إضافة للطلب"
      },
      loyalty_program: {
        title: "برنامج الولاء",
        description: "بناء ولاء العملاء بنظام المكافآت بالنقاط",
        enable_program: "تفعيل برنامج الولاء",
        program_name: "اسم البرنامج",
        points_per_dollar: "نقاط لكل دولار",
        min_redeem: "الحد الأدنى لاستبدال النقاط",
        point_value: "قيمة النقطة",
        total_members: "إجمالي الأعضاء",
        active_members: "الأعضاء النشطون",
        points_earned: "النقاط المكتسبة",
        points_redeemed: "النقاط المستبدلة"
      },
      onboarding: {
        welcome_title: "مرحباً بك في قائمة مافن هب!",
        welcome_description: "حل إدارة المطاعم الشامل الخاص بك",
        step_restaurant_setup: "إعداد مطعمك",
        step_branches: "إضافة مواقعك",
        step_menu: "إنشاء قائمتك الرقمية",
        step_qr_codes: "إنشاء رموز QR",
        step_orders: "اختبار نظام الطلبات",
        step_customization: "تخصيص علامتك التجارية",
        step_staff: "إضافة أعضاء الفريق",
        step_analytics: "استكشاف التحليلات",
        congratulations: "أنت جاهز الآن!",
        next: "التالي",
        previous: "السابق",
        skip: "تخطي الخطوة",
        complete: "إكمال"
      },
      kitchen_display: {
        title: "شاشة المطبخ",
        description: "إدارة الطلبات في الوقت الفعلي لطاقم المطبخ",
        active_orders: "الطلبات النشطة",
        total_items: "إجمالي العناصر",
        ready_items: "العناصر الجاهزة",
        avg_prep_time: "متوسط وقت التحضير",
        all_stations: "جميع المحطات",
        start_cooking: "بدء",
        mark_ready: "جاهز",
        complete_order: "إكمال الطلب",
        urgent: "عاجل",
        high: "عالي",
        normal: "عادي"
      },
      advanced_analytics: {
        title: "التحليلات المتقدمة",
        description: "رؤى شاملة حول أداء المطعم",
        total_revenue: "إجمالي الإيرادات",
        total_orders: "إجمالي الطلبات",
        avg_order_value: "متوسط قيمة الطلب",
        total_customers: "إجمالي العملاء",
        overview: "نظرة عامة",
        sales: "المبيعات",
        customers: "العملاء",
        menu_performance: "أداء القائمة",
        operations: "العمليات",
        revenue_trend: "اتجاه الإيرادات",
        order_types: "أنواع الطلبات",
        peak_hours: "تحليل ساعات الذروة",
        customer_insights: "رؤى العملاء",
        top_customers: "أفضل العملاء",
        pickup: "استلام",
        delivery: "توصيل",
        dine_in: "تناول في المطعم",
        customer_retention_rate: "نسبة الاحتفاظ بالعملاء",
        new_customer_rate: "نسبة العملاء الجدد",
        avg_order_frequency: "متوسط تكرار الطلب",
        customer_lifetime_value: "القيمة الدائمة للعميل",
        export_started: "بدأ التصدير",
        exporting_as: "جاري تصدير بيانات التحليلات بصيغة {{format}}...",
        no_analytics_data: "لا توجد بيانات تحليلية",
        no_orders_message: "{{branch}} ليس لديه طلبات في الفترة المحددة. ابدأ باستقبال الطلبات لرؤية التحليلات.",
        refresh: "تحديث",
        export: "تصدير",
        select_branch: "اختر الفرع",
        vs_previous_period: "مقارنة بالفترة السابقة",
        vs_last_period: "مقارنة بالفترة الماضية",
        orders: "طلبات",
        new_customers: "عملاء جدد",
        returning_customers: "عملاء عائدون",
        customer_segmentation: "تصنيف العملاء",
        top_performing_items: "أفضل الأصناف أداءً",
        top_items_description: "الأصناف الأكثر مبيعاً حسب الكمية والإيرادات لفرع {{branch}}",
        loading_menu_performance: "جاري تحميل بيانات أداء القائمة...",
        no_menu_data: "لا تتوفر بيانات أداء للقائمة حتى الآن",
        no_menu_data_desc: "ستظهر البيانات بعد أن يطلب العملاء من القائمة.",
        menu_data_tips: "• تأكد من إضافة أصناف للقائمة\n• تأكد من استلام طلبات تحتوي على أصناف\n• تأكد من عدم إلغاء الطلبات",
        sold: "مباع",
        revenue: "الإيرادات",
        avg: "المتوسط",
        items_sold: "الأصناف المباعة",
        total_units: "إجمالي الوحدات",
        no_sales_yet: "لا توجد مبيعات بعد",
        average_price: "متوسط السعر",
        per_item: "للصنف",
        popular_items: "الأصناف الشائعة",
        no_revenue_yet: "لا توجد إيرادات بعد",
        menu_performance_insights: "رؤى أداء القائمة",
        top_revenue_generator: "أعلى مولد للإيرادات",
        of_total_menu_revenue: "من إجمالي إيرادات القائمة",
        most_sold_item: "الصنف الأكثر مبيعاً",
        units: "وحدات",
        of_total_units_sold: "من إجمالي الوحدات المباعة",
        operational_metrics: "مقاييس التشغيل",
        order_fulfillment_rate: "نسبة إكمال الطلبات",
        avg_prep_time: "متوسط وقت التحضير",
        active_branches: "الفروع النشطة",
        branch_performance: "أداء الفروع",
        no_branches_configured: "لا توجد فروع مضافة",
        today: "اليوم",
        days_7: "7 أيام",
        days_30: "30 يوم",
        days_90: "90 يوم",
        year_1: "سنة",
        total_revenue_label: "إجمالي الإيرادات",
        total_orders_summary: "إجمالي الطلبات",
        avg_order_summary: "متوسط قيمة الطلب",
        orders_label: "طلبات",
        avg_short: "متوسط",
        min: "دقيقة",
        top_performing_items_desc: "الأصناف الأكثر شيوعاً حسب حجم المبيعات والإيرادات لـ {{branchName}}",
        menu_tip_1: "تأكد من إضافة أصناف للقائمة",
        menu_tip_2: "تأكد من استلام طلبات تحتوي على أصناف",
        menu_tip_3: "تأكد من عدم إلغاء الطلبات"
      },
      dialogs: {
        create_branch: {
          title: 'إضافة فرع جديد',
          name_label: 'اسم الفرع *',
          name_placeholder: 'مثال: فرع وسط البلد',
          address_label: 'العنوان',
          address_placeholder: '123 الشارع الرئيسي، المدينة، الدولة',
          phone_label: 'الهاتف',
          phone_placeholder: '+1 234 567 8900',
          whatsapp_label: 'واتساب',
          instagram_label: 'انستغرام',
          instagram_placeholder: '@username',
          facebook_label: 'فيسبوك',
          facebook_placeholder: 'facebook.com/page',
          website_label: 'الموقع الإلكتروني',
          website_placeholder: 'https://example.com',
          cancel_button: 'إلغاء',
          create_button: 'إنشاء فرع',
          creating_button: 'جار الإنشاء...',
          toast_error_title: 'خطأ',
          toast_error_name_required: 'اسم الفرع مطلوب',
          toast_success_title: 'نجاح',
          toast_success_description: 'تم إنشاء الفرع بنجاح!',
          toast_error_failed: 'فشل إنشاء الفرع'
        },
        edit_branch: {
          title: 'تعديل الفرع',
          description: 'تحديث معلومات مطعمك وفرعك.',
          restaurant_name_label: 'اسم المطعم *',
          restaurant_name_placeholder: 'مثال: قصر البيتزا',
          restaurant_description_label: 'وصف المطعم',
          restaurant_description_placeholder: 'وصف موجز لمطعمك...',
          branch_name_label: 'اسم الفرع *',
          branch_name_placeholder: 'مثال: فرع وسط البلد',
          slug_label: 'رابط URL للفرع *',
          slug_placeholder: 'downtown-location',
          slug_description: 'سيتم استخدام هذا في رابط قائمة QR الخاصة بك: /menu/{{slug}}',
          address_label: 'العنوان',
          address_placeholder: '123 الشارع الرئيسي، المدينة، الدولة',
          phone_label: 'الهاتف',
          phone_placeholder: '+1 234 567 8900',
          whatsapp_label: 'واتساب',
          instagram_label: 'انستغرام',
          instagram_placeholder: '@yourrestaurant',
          facebook_label: 'فيسبوك',
          facebook_placeholder: 'yourrestaurant',
          website_label: 'الموقع الإلكتروني',
          website_placeholder: 'https://yourrestaurant.com',
          cancel_button: 'إلغاء',
          save_button: 'حفظ التغييرات',
          saving_button: 'جار الحفظ...',
          toast_error_title: 'خطأ',
          toast_error_slug_taken: 'اسم الفرع هذا مستخدم بالفعل. يرجى اختيار اسم مختلف.',
          toast_error_failed: 'فشل تحديث الفرع. يرجى المحاولة مرة أخرى.',
          toast_success_title: 'نجاح!',
          toast_success_description: 'تم تحديث معلومات الفرع والمطعم بنجاح.',
        },
        create_category: {
          title: 'إنشاء فئة جديدة',
          description: 'أضف فئة جديدة لتنظيم عناصر القائمة الخاصة بك.',
          name_label: 'اسم الفئة *',
          name_placeholder: 'مثال: مقبلات، أطباق رئيسية',
          description_label: 'الوصف',
          description_placeholder: 'وصف موجز لهذه الفئة...',
          image_label: 'صورة الفئة',
          image_upload_button: 'انقر لتحميل صورة',
          cancel_button: 'إلغاء',
          create_button: 'إنشاء فئة',
          creating_button: 'جار الإنشاء...',
          toasts: {
            image_upload_success_title: 'نجاح!',
            image_upload_success_desc: 'تم تحميل الصورة بنجاح.',
            image_upload_error_title: 'خطأ',
            image_upload_error_desc: 'فشل تحميل الصورة.',
            create_success_title: 'نجاح!',
            create_success_desc: 'تم إنشاء الفئة بنجاح.',
            create_error_title: 'خطأ',
            create_error_desc: 'فشل إنشاء الفئة. يرجى المحاولة مرة أخرى.'
          }
        },
        create_menu_item: {
          title: 'إنشاء عنصر قائمة جديد',
          description: 'أضف عنصرًا جديدًا إلى فئة القائمة الخاصة بك.',
          name_label: 'اسم العنصر *',
          name_placeholder: 'مثال: بيتزا مارجريتا',
          description_label: 'الوصف',
          description_placeholder: 'صف المكونات والتحضير...',
          price_label: 'السعر الأساسي *',
          price_placeholder: '19.99',
          image_label: 'صورة العنصر',
          image_upload_button: 'انقر لتحميل صورة',
          featured_label: 'عنصر مميز',
          available_label: 'متوفر',
          cancel_button: 'إلغاء',
          create_button: 'إنشاء عنصر القائمة',
          creating_button: 'جار الإنشاء...',
          toasts: {
            image_upload_success_title: 'نجاح!',
            image_upload_success_desc: 'تم تحميل الصورة بنجاح.',
            image_upload_error_title: 'خطأ',
            image_upload_error_desc: 'فشل تحميل الصورة.',
            create_success_title: 'نجاح!',
            create_success_desc: 'تم إنشاء عنصر القائمة بنجاح.',
            create_error_title: 'خطأ',
            create_error_desc: 'فشل إنشاء عنصر القائمة. يرجى المحاولة مرة أخرى.'
          },
          variants: {
            title: 'الأحجام (اختياري)',
            subtitle: 'أضف أحجام أو خيارات مختلفة بأسعار وأوصاف مختلفة.',
            size_placeholder: 'اسم الحجم (مثال: صغير، وسط، كبير)',
            price_placeholder: 'السعر',
            description_placeholder: 'وصف الحجم (اختياري) - مثال: المعلومات الغذائية، السعرات الحرارية...',
            add_button: 'إضافة حجم',
            save_button: 'حفظ',
            cancel_button: 'إلغاء',
            no_variants: 'لم تتم إضافة أحجام بعد.',
            edit: 'تعديل',
            delete: 'حذف'
          }
        },
        edit_category: {
          title: 'تعديل الفئة',
          description: 'تحديث تفاصيل فئة القائمة الخاصة بك.',
          name_label: 'اسم الفئة *',
          name_placeholder: 'مثال: مقبلات، أطباق رئيسية',
          description_label: 'الوصف',
          description_placeholder: 'وصف موجز لهذه الفئة...',
          image_label: 'صورة الفئة',
          image_upload_button: 'انقر لتحميل صورة',
          active_label: 'الفئة نشطة',
          cancel_button: 'إلغاء',
          update_button: 'تحديث الفئة',
          updating_button: 'جار التحديث...',
          toasts: {
            image_upload_success_title: 'نجاح!',
            image_upload_success_desc: 'تم تحميل الصورة بنجاح.',
            image_upload_error_title: 'خطأ',
            image_upload_error_desc: 'فشل تحميل الصورة.',
            update_success_title: 'نجاح!',
            update_success_desc: 'تم تحديث الفئة بنجاح.',
            update_error_title: 'خطأ',
            update_error_desc: 'فشل تحديث الفئة. يرجى المحاولة مرة أخرى.'
          }
        },
        delete_confirm: {
          title: 'تأكيد الحذف',
          description: 'هل أنت متأكد من حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.',
          cancel_button: 'إلغاء',
          delete_button: 'حذف',
          deleting_button: 'جار الحذف...'
        },
        edit_menu_item: {
          title: 'تعديل عنصر القائمة',
          description: 'قم بتحديث تفاصيل هذا العنصر.',
          name_label: 'الاسم',
          name_placeholder: 'أدخل اسم العنصر',
          description_label: 'الوصف',
          description_placeholder: 'أدخل وصف العنصر',
          price_label: 'السعر',
          price_placeholder: 'أدخل السعر',
          image_label: 'الصورة',
          upload_prompt: 'انقر للرفع أو اسحب وأفلت',
          upload_formats: 'JPG, PNG, أو WebP (حد أقصى 10 ميجابايت)',
          drop_image_prompt: 'أفلت الصورة هنا',
          uploading: 'جاري الرفع...',
          featured_label: 'مميز',
          available_label: 'متوفر',
          cancel_button: 'إلغاء',
          update_button: 'تحديث',
          updating_button: 'جاري التحديث...',
          toasts: {
            image_upload_success_title: 'تم رفع الصورة',
            image_upload_success_desc: 'تم رفع الصورة بنجاح.',
            image_upload_error_title: 'خطأ في الرفع',
            image_upload_error_desc: 'فشل في رفع الصورة.',
            update_success_title: 'نجاح',
            update_success_desc: 'تم تحديث العنصر بنجاح.',
            update_error_title: 'خطأ',
            update_error_desc: 'فشل في تحديث العنصر.'
          }
        }
      },
      orders: {
        my_orders: "طلباتي",
        orders: "طلبات",
        no_orders: "لا توجد طلبات بعد",
        error_loading: "خطأ في تحميل الطلبات",
        items: "العناصر",
        order_number: "رقم الطلب #",
        status: "الحالة",
        date: "التاريخ",
        total: "المجموع",
        status_labels: {
          pending: 'قيد الانتظار',
          confirmed: 'مؤكد',
          preparing: 'قيد التحضير',
          ready: 'جاهز',
          completed: 'مكتمل',
          cancelled: 'ملغي'
        },
        delivery_status: {
          assigned: 'مُكلف',
          accepted: 'مقبول',
          picked_up: 'تم الاستلام',
          in_transit: 'في الطريق',
          delivered: 'تم التسليم',
          cancelled: 'ملغي'
        },
      },
      tables: {
        title: 'إدارة الطاولات',
        description: 'إعداد وإدارة طاولات المطعم',
        add_table: 'إضافة طاولة',
        edit_table: 'تعديل طاولة',
        delete_table: 'حذف طاولة',
        table_number: 'رقم الطاولة',
        table_name: 'اسم الطاولة (اختياري)',
        capacity: 'السعة',
        section: 'القسم',
        is_active: 'نشط',
        notes: 'ملاحظات',
        qr_code: 'رمز QR',
        generate_qr: 'إنشاء رمز QR',
        download_qr: 'تحميل QR',
        no_tables: 'لا توجد طاولات مُعدة بعد',
        no_tables_hint: 'أضف طاولات لتفعيل الطلب عبر رمز QR',
        select_branch_hint: 'الرجاء اختيار فرع لإدارة الطاولات',
        qr_for_table: 'رمز QR للطاولة {{table}}',
        qr_dialog_description: 'امسح هذا الرمز لفتح القائمة مع اختيار الطاولة تلقائياً',
        qr_downloaded: 'تم تحميل رمز QR',
        qr_downloaded_desc: 'تم حفظ رمز QR على جهازك',
        url_copied: 'تم نسخ الرابط',
        copy_url: 'نسخ الرابط',
        open_menu: 'فتح القائمة',
        sections: {
          indoor: 'داخلي',
          outdoor: 'خارجي',
          bar: 'بار',
          vip: 'VIP',
          patio: 'فناء',
          private: 'غرفة خاصة'
        },
        form: {
          table_number_placeholder: 'مثال: 1، A1، T-05',
          table_name_placeholder: 'مثال: طاولة النافذة، كابينة 3',
          capacity_placeholder: 'عدد المقاعد',
          section_placeholder: 'اختر القسم',
          notes_placeholder: 'ملاحظات إضافية عن الطاولة...'
        },
        messages: {
          created: 'تم إنشاء الطاولة بنجاح',
          updated: 'تم تحديث الطاولة بنجاح',
          deleted: 'تم حذف الطاولة بنجاح',
          qr_generated: 'تم إنشاء رمز QR بنجاح'
        },
        errors: {
          duplicate: 'طاولة بهذا الرقم موجودة مسبقاً',
          limit_reached: 'تم الوصول للحد الأقصى من الطاولات. قم بالترقية لإضافة المزيد.',
          not_found: 'الطاولة غير موجودة',
          create_failed: 'فشل في إنشاء الطاولة',
          update_failed: 'فشل في تحديث الطاولة',
          delete_failed: 'فشل في حذف الطاولة',
          qr_download_failed: 'فشل في تحميل رمز QR'
        },
        confirm_delete: 'هل أنت متأكد من حذف هذه الطاولة؟',
        limit_info: '{{current}} من {{limit}} طاولة مستخدمة',
        upgrade_for_tables: 'قم بالترقية إلى Pro أو Enterprise لتفعيل إدارة الطاولات'
      },
      audit: {
        title: 'سجل التغييرات',
        description: 'تتبع جميع التغييرات والأنشطة في مطعمك',
        upgrade_required: 'سجل التغييرات - ميزة مدفوعة',
        upgrade_description: 'قم بالترقية إلى خطة Enterprise للوصول إلى سجل التغييرات المفصل وتتبع الأنشطة.',
        no_logs: 'لا توجد سجلات',
        no_logs_description: 'لم يتم تسجيل أي نشاط بعد أو لا توجد سجلات تطابق الفلاتر.',
        search_placeholder: 'البحث بالاسم أو الكيان...',
        all_actions: 'كل الإجراءات',
        all_entities: 'كل الكيانات',
        all_branches: 'كل الفروع',
        action: 'الإجراء',
        entity_type: 'نوع الكيان',
        entity: 'الكيان',
        entity_name: 'اسم الكيان',
        entity_id: 'معرف الكيان',
        user: 'المستخدم',
        timestamp: 'الوقت',
        start_date: 'من تاريخ',
        end_date: 'إلى تاريخ',
        log_details: 'تفاصيل السجل',
        changes: 'التغييرات',
        metadata: 'تفاصيل إضافية',
        technical_info: 'معلومات تقنية',
        showing: 'عرض',
        actions: {
          create: 'إنشاء',
          update: 'تعديل',
          delete: 'حذف',
          login: 'تسجيل دخول',
          logout: 'تسجيل خروج',
          permission_change: 'تغيير صلاحيات',
          status_change: 'تغيير حالة',
          export: 'تصدير',
          import: 'استيراد',
          other: 'أخرى'
        },
        entities: {
          order: 'طلب',
          menu_item: 'صنف',
          category: 'تصنيف',
          branch: 'فرع',
          staff: 'موظف',
          table: 'طاولة',
          inventory: 'مخزون',
          material: 'مادة',
          recipe: 'وصفة',
          settings: 'إعدادات',
          subscription: 'اشتراك',
          payment: 'دفعة',
          customer: 'عميل',
          reservation: 'حجز',
          authentication: 'تسجيل دخول/خروج',
          transaction: 'معاملة مالية',
          expense: 'مصروف',
          account: 'حساب'
        }
      }
    },
    staff_management: {
      title: 'إدارة الموظفين',
      subtitle: 'إدارة أعضاء فريقك ومستويات الوصول الخاصة بهم',
      create_staff: 'إنشاء موظف جديد',
      staff_list: 'أعضاء الطاقم',
      form: {
        username: 'اسم المستخدم',
        username_placeholder: 'أدخل اسم المستخدم',
        password: 'كلمة المرور',
        password_placeholder: 'أدخل كلمة المرور',
        role: 'الدور',
        role_placeholder: 'اختر الدور',
        submit: 'إنشاء موظف',
        cancel: 'إلغاء'
      },
      roles: {
        OWNER: 'المالك',
        MANAGER: 'مدير',
        CASHIER: 'كاشير',
        VIEWER: 'مراقب'
      },
      messages: {
        create_success: 'تم إنشاء الموظف بنجاح',
        create_error: 'فشل في إنشاء الموظف',
        load_error: 'فشل في تحميل الموظفين',
        access_denied: 'تم رفض الوصول. المالكون فقط يمكنهم إدارة الموظفين.',
        no_restaurant: 'لم يتم العثور على المطعم.'
      },
      login: {
        title: 'تسجيل دخول الموظفين',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        login_button: 'تسجيل الدخول كموظف',
        switch_to_owner: 'تسجيل الدخول كمالك',
        error: 'اسم المستخدم أو كلمة المرور غير صحيحة'
      }
    },
    rider: {
      loading: 'جاري التحميل...',
      dashboard_title: 'لوحة تحكم السائق',
      welcome_back: 'أهلاً بعودتك، {{name}}!',
      logout: 'تسجيل الخروج',
      customer: 'العميل',
      order_number: 'طلب #{{number}}',
      assigned_at: 'تم التعيين',
      delivery_address: 'عنوان التسليم',
      order_total: 'إجمالي الطلب',
      estimated_time: 'الوقت المتوقع',
      minutes: 'دقيقة',
      your_earning: 'أرباحك',
      special_instructions: 'تعليمات خاصة',
      min: 'دقيقة',
      no_active_deliveries: 'لا توجد توصيلات نشطة',
      waiting_for_deliveries: 'سوف تظهر التوصيلات الجديدة هنا عند التعيين',
      set_status_available: 'اضبط حالتك على "متاح" لاستلام التوصيلات',
      no_delivery_history: 'لا يوجد سجل توصيل',
      completed_deliveries_appear: 'ستظهر التوصيلات المكتملة هنا',
      today_performance: 'أداء اليوم',
      deliveries_completed: 'التوصيلات المكتملة',
      total_earnings: 'إجمالي الأرباح',
      avg_delivery_time: 'متوسط وقت التوصيل',
      alltime_statistics: 'إحصائيات كل الأوقات',
      total_deliveries: 'إجمالي التوصيلات',
      success_rate: 'معدل النجاح',
      rider_status: {
        available: 'متاح',
        busy: 'مشغول',
        on_break: 'في استراحة',
        offline: 'غير متصل'
      },
      status: {
        assigned: 'معين',
        accepted: 'مقبول',
        picked_up: 'تم الاستلام',
        in_transit: 'في الطريق',
        delivered: 'تم التسليم',
        failed: 'فشل',
        cancelled: 'ملغي'
      },
      stats: {
        active_deliveries: 'التوصيلات النشطة',
        today_deliveries: 'توصيلات اليوم',
        today_earnings: 'أرباح اليوم',
        average_rating: 'متوسط التقييم'
      },
      tabs: {
        active_deliveries: 'التوصيلات النشطة',
        history: 'السجل',
        earnings_stats: 'الأرباح والإحصائيات'
      },
      actions: {
        accept_order: 'قبول الطلب',
        decline_order: 'رفض الطلب',
        mark_picked_up: 'تم الاستلام',
        out_for_delivery: 'في طريق التوصيل',
        mark_delivered: 'تم التسليم'
      },
      confirm_decline: 'تأكيد الرفض',
      decline_confirmation_message: 'هل أنت متأكد من رغبتك في رفض هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.',
      decline_button: 'رفض',
      confirm_decline_button: 'نعم، رفض الطلب',
      cancel: 'إلغاء'
    }
  },
  cart: {
    items: "عناصر",
    title: "طلبك",
    subtotal: "المجموع الفرعي",
    loyalty_discount: "خصم الولاء",
    loading_zones: "جاري تحميل المناطق...",
    minimum_order: "الحد الأدنى للطلب",
    suggestions_title: "هذه الأصناف تتناسب جيداً مع طلبك الحالي",
    add_to_order: "أضف إلى الطلب",
    total: "الإجمالي",
    contact_info: "معلومات التواصل",
    order_type: "نوع الطلب",
    pickup: "استلام",
    delivery: "توصيل",
    dine_in: "تناول في المطعم",
    select_order_type: "كيف تود استلام طلبك؟",
    name_label: "الاسم",
    name_optional: "الاسم (اختياري)",
    name_placeholder: "اكتب اسمك الكامل",
    phone_label: "الهاتف",
    phone_optional: "رقم الهاتف (اختياري)",
    phone_placeholder: "اكتب رقم هاتفك",
    email_label: "البريد الإلكتروني",
    email_placeholder: "عنوان بريدك الإلكتروني",
    address_label: "عنوان التوصيل",
    address_placeholder: "اكتب عنوانك بالتفصيل (اسم الشارع، رقم المبنى، رقم الشقة)",
    table_number_label: "رقم الطاولة",
    table_number_placeholder: "أدخل رقم طاولتك",
    delivery_zone_label: "منطقة التوصيل",
    delivery_zone_placeholder: "اختر منطقة التوصيل",
    delivery_fee: "رسوم التوصيل",
    estimated_delivery: "وقت التوصيل المتوقع",
    estimated_pickup: "وقت الاستلام المتوقع",
    minutes: "دقيقة",
    notes_label: "ملاحظات خاصة",
    notes_optional: "ملاحظات (اختياري)",
    notes_placeholder: "أي ملاحظات خاصة أو طلبات إضافية",
    auto_selected_qr: "تم تحديد نوع الطلب تلقائياً من رمز QR",
    table_prefix: "طاولة",
    send_order: "إرسال الطلب",
    order_success_title: "تم إرسال الطلب!",
    order_success_desc: "تم استلام طلبك.",
    order_error_title: "خطأ",
    order_error_desc: "فشل إرسال الطلب. يرجى المحاولة مرة أخرى.",
    missing_info_title: "معلومات ناقصة",
    missing_info_desc: "يرجى تقديم اسمك ورقم هاتفك.",
    missing_table_number: "يرجى تقديم رقم طاولتك لطلبات تناول الطعام في المطعم.",
    missing_delivery_address: "يرجى تقديم عنوان التوصيل.",
    missing_delivery_zone: "يرجى اختيار منطقة التوصيل لطلبات التوصيل.",
    delivery_minimum_not_met: "إجمالي الطلب لا يحقق الحد الأدنى لهذه منطقة التوصيل.",
    empty_cart_title: "السلة فارغة",
    empty_cart_desc: "الرجاء إضافة عناصر إلى سلتك قبل الطلب.",
    no_delivery_zones: "لا توجد مناطق توصيل متاحة لهذا الموقع.",
    order_limit_reached_title: "تم الوصول للحد الأقصى للطلبات",
    order_limit_reached_desc: "وصل هذا المطعم للحد الأقصى من الطلبات الشهرية. يرجى التواصل مع المطعم للمساعدة."
  },
  subscription: {
    upgrade_required: 'مطلوب ترقية الباقة',
    feature_not_available: 'هذه الميزة غير متوفرة في باقتك الحالية',
    upgrade_to_continue: 'يرجى ترقية اشتراكك للمتابعة.',
    limit_reached: 'تم الوصول للحد الأقصى',
    order_limit_reached: 'تم الوصول لحد الطلبات الشهري',
    order_limit_message: 'استخدمت {{current}} من {{limit}} طلب هذا الشهر. يرجى الترقية للاستمرار في معالجة الطلبات.',
    order_limit_warning: 'أنت على وشك الوصول لحد الطلبات الشهري ({{current}}/{{limit}}). فكر في الترقية قريباً.',
    branches_limit_message: 'استخدمت {{current}} من {{limit}} فرع. يرجى الترقية لإضافة المزيد من الفروع.',
    branches_limit_warning: 'أنت على وشك الوصول لحد الفروع ({{current}}/{{limit}}). فكر في الترقية قريباً.',
    staff_limit_message: 'استخدمت {{current}} من {{limit}} موظف. يرجى الترقية لإضافة المزيد من الموظفين.',
    staff_limit_warning: 'أنت على وشك الوصول لحد الموظفين ({{current}}/{{limit}}). فكر في الترقية قريباً.',
    menu_items_limit_message: 'استخدمت {{current}} من {{limit}} صنف. يرجى الترقية لإضافة المزيد من الأصناف.',
    menu_items_limit_warning: 'أنت على وشك الوصول لحد الأصناف ({{current}}/{{limit}}). فكر في الترقية قريباً.',
    categories_limit_message: 'استخدمت {{current}} من {{limit}} قسم. يرجى الترقية لإضافة المزيد من الأقسام.',
    categories_limit_warning: 'أنت على وشك الوصول لحد الأقسام ({{current}}/{{limit}}). فكر في الترقية قريباً.',
    export_upgrade: 'تصدير البيانات متاح في خطة برو والمؤسسة. قم بالترقية لتصدير بياناتك.',
    limit_reached_details: {
      branches: 'وصلت للحد الأقصى لعدد الفروع',
      staff: 'وصلت للحد الأقصى لعدد الموظفين',
      menu_items: 'وصلت للحد الأقصى لعدد الأصناف في القائمة',
      categories: 'وصلت للحد الأقصى لعدد الأقسام',
      tables: 'وصلت للحد الأقصى لعدد الطاولات',
      orders: 'وصلت لحد الطلبات الشهري',
      storage: 'وصلت لحد مساحة التخزين'
    },
    upgrade_now: 'ترقية الآن',
    view_plans: 'عرض الباقات',
    plan_comparison: 'مقارنة الباقات',
    current_plan: 'الباقة الحالية',
    trial_info: {
      days_remaining: 'باقي {{days}} يوم في الفترة التجريبية',
      expired: 'انتهت الفترة التجريبية',
      upgrade_prompt: 'رقّي باقتك للاستمرار في استخدام جميع الميزات'
    },
    features: {
      inventory: 'إدارة المخزون',
      analytics: 'التحليلات والتقارير',
      marketing: 'أدوات التسويق',
      loyalty: 'برنامج الولاء',
      delivery: 'إدارة التوصيل',
      finance: 'التقارير المالية',
      waiting_list: 'قائمة الانتظار',
      qr_ordering: 'الطلب عبر QR',
      online_ordering: 'الطلب الإلكتروني',
      api_access: 'الوصول للـ API',
      custom_branding: 'تخصيص العلامة التجارية',
      priority_support: 'دعم فني ذو أولوية',
      multi_branch: 'إدارة فروع متعددة',
      advanced_reports: 'تقارير متقدمة'
    },
    tiers: {
      none: 'غير متوفر',
      basic: 'أساسي',
      advanced: 'متقدم',
      enterprise: 'مؤسسات',
      required: 'المستوى المطلوب: {{tier}}'
    },
    features_by_tier: {
      inventory_basic: 'عرض وتحديث مستويات المخزون',
      inventory_advanced: 'الوصفات، التحليلات، تتبع الهدر، الجرد الفعلي',
      analytics_basic: 'نظرة عامة على المقاييس الرئيسية',
      analytics_advanced: 'الرسوم البيانية، الاتجاهات، التقارير المخصصة',
      marketing_basic: 'العروض الترويجية والخصومات',
      marketing_advanced: 'الحملات، رؤى العملاء',
      loyalty_basic: 'إعدادات النقاط، قائمة العملاء',
      loyalty_advanced: 'التحليلات، المكافآت المخصصة'
    },
    plans: {
      basic: 'الباقة الأساسية',
      pro: 'الباقة الاحترافية',
      enterprise: 'باقة المؤسسات',
      trial: 'الفترة التجريبية'
    },
    usage_overview: 'نظرة عامة على الاستخدام',
    usage_description: 'تتبع استخدام الموارد مقارنة بحدود باقتك',
    resources: {
      branches: 'الفروع',
      branches_desc: 'مواقع المطعم',
      staff: 'الموظفين',
      staff_desc: 'حسابات الموظفين',
      menu_items: 'عناصر القائمة',
      menu_items_desc: 'إجمالي عناصر القائمة',
      categories: 'الأقسام',
      categories_desc: 'أقسام القائمة',
      monthly_orders: 'الطلبات الشهرية',
      monthly_orders_desc: 'الطلبات هذا الشهر',
      storage: 'التخزين',
      storage_desc: 'ملفات مرفوعة',
      storage_gb: 'جيجابايت مستخدمة'
    }
  },
  kds: {
    title: 'شاشة المطبخ',
    active_orders: 'طلبات نشطة',
    no_orders: 'لا توجد طلبات نشطة',
    waiting: 'في انتظار طلبات جديدة...',
    columns: {
      new: 'طلبات جديدة',
      preparing: 'قيد التحضير',
      ready: 'جاهز'
    },
    status: {
      pending: 'جديد',
      confirmed: 'مؤكد',
      preparing: 'قيد التحضير',
      ready: 'جاهز',
      completed: 'مكتمل'
    },
    actions: {
      confirm: 'تأكيد الطلب',
      start_preparing: 'بدء التحضير',
      mark_ready: 'تحديد كجاهز',
      complete: 'إكمال ومسح'
    },
    messages: {
      status_updated: 'تم تحديث حالة الطلب'
    },
    errors: {
      fetch_failed: 'فشل في تحميل الطلبات',
      update_failed: 'فشل في تحديث الطلب',
      no_branch: 'الرجاء اختيار فرع'
    }
  },
  finance: {
    overview: 'نظرة عامة',
    profit_loss: 'الأرباح والخسائر',
    cash_flow: 'التدفق النقدي',
    balance_sheet: 'الميزانية العمومية',
    expenses: 'المصروفات',
    upgrade_required_title: 'التقارير المالية المتقدمة',
    upgrade_required_desc: 'قم بالترقية إلى خطة برو أو المؤسسة للوصول إلى التقارير المالية المفصلة بما في ذلك قوائم الأرباح والخسائر وتتبع المصروفات وتحليل التدفق النقدي والميزانيات العمومية.',
    basic_feature_hint: 'مع خطتك الحالية، يمكنك عرض تقارير المبيعات اليومية في صفحة الطلبات.',
    enterprise_feature: 'ميزة المؤسسة',
    cash_flow_upgrade: 'تحليل التدفق النقدي متاح في خطة المؤسسة. قم بالترقية لتتبع حركة النقد بالتفصيل.',
    balance_sheet_upgrade: 'إدارة الميزانية العمومية والحسابات المالية متاحة في خطة المؤسسة. قم بالترقية لتتبع الأصول والالتزامات وحقوق الملكية.'
  },
  marketing: {
    upgradeTitle: 'فتح ميزات التسويق المتقدمة',
    upgradeDescription: 'قم بالترقية للوصول إلى حملات الرسائل القصيرة/واتساب، وتحليلات العملاء، والإحصائيات التفصيلية',
    promotionalOffers: 'العروض الترويجية',
    campaigns: 'الحملات',
    customerInsights: 'تحليلات العملاء',
    createOffer: 'إنشاء عرض',
    createCampaign: 'إنشاء حملة',
    noOffers: 'لم يتم إنشاء عروض ترويجية بعد',
    noOffersHint: 'أنشئ أول عرض ترويجي لجذب العملاء',
    noCampaigns: 'لم يتم إنشاء حملات بعد',
    noCampaignsHint: 'أنشئ أول حملة تسويقية للتواصل مع العملاء',
    offerName: 'اسم العرض',
    promoCode: 'كود الخصم',
    discountType: 'نوع الخصم',
    percentageDiscount: 'خصم بالنسبة المئوية',
    fixedDiscount: 'خصم بمبلغ ثابت',
    minOrder: 'الحد الأدنى للطلب',
    usageLimit: 'حد الاستخدام',
    description: 'الوصف',
    campaignName: 'اسم الحملة',
    campaignType: 'نوع الحملة',
    targetAudience: 'الجمهور المستهدف',
    allCustomers: 'جميع العملاء',
    newCustomers: 'العملاء الجدد',
    returningCustomers: 'العملاء العائدون',
    inactiveCustomers: 'العملاء غير النشطين',
    vipCustomers: 'العملاء المميزون',
    messageTemplate: 'قالب الرسالة',
    start: 'بدء',
    totalCampaigns: 'إجمالي الحملات',
    messagesSent: 'الرسائل المرسلة',
    deliveryRate: 'معدل التسليم',
    marketingCost: 'تكلفة التسويق',
    topCustomers: 'أفضل العملاء',
    orders: 'طلبات',
    avgOrder: 'متوسط',
    lowRisk: 'خطر منخفض',
    mediumRisk: 'خطر متوسط',
    highRisk: 'خطر مرتفع'
  },
  reservations: {
    title: 'الحجوزات',
    subtitle: 'إدارة حجوزات الطاولات',
    upgradeDescription: 'إدارة حجوزات الطاولات لمطعمك',
    upgradePrompt: 'وحدة الحجوزات متاحة في الباقات الاحترافية والمؤسسات. قم بالترقية لإدارة حجوزات الطاولات.',
    newReservation: 'حجز جديد',
    editReservation: 'تعديل الحجز',
    newReservationDescription: 'إنشاء حجز طاولة جديد',
    editReservationDescription: 'تحديث تفاصيل الحجز',
    createReservation: 'إنشاء الحجز',
    saveChanges: 'حفظ التغييرات',
    customerName: 'اسم العميل',
    namePlaceholder: 'أدخل اسم العميل',
    phone: 'الهاتف',
    phonePlaceholder: '+966 50 123 4567',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'email@example.com',
    date: 'التاريخ',
    time: 'الوقت',
    partySize: 'عدد الأشخاص',
    person: 'شخص',
    people: 'أشخاص',
    guests: 'ضيوف',
    duration: 'المدة',
    tableNumber: 'رقم الطاولة',
    tablePlaceholder: 'مثال: طاولة 5، الشرفة أ',
    table: 'طاولة',
    specialRequests: 'طلبات خاصة',
    specialRequestsPlaceholder: 'أي متطلبات غذائية، مناسبات، إلخ.',
    internalNotes: 'ملاحظات داخلية',
    internalNotesPlaceholder: 'ملاحظات للموظفين فقط',
    notes: 'ملاحظات',
    today: 'اليوم',
    listTitle: 'الحجوزات في',
    filterByStatus: 'تصفية حسب الحالة',
    noReservations: 'لا توجد حجوزات',
    noReservationsDescription: 'لا توجد حجوزات للتاريخ المحدد.',
    created: 'تم إنشاء الحجز',
    createdDescription: 'تم إنشاء الحجز بنجاح.',
    updated: 'تم تحديث الحجز',
    updatedDescription: 'تم تحديث الحجز.',
    deleted: 'تم حذف الحجز',
    deletedDescription: 'تم إزالة الحجز.',
    deleteTitle: 'حذف الحجز؟',
    deleteDescription: 'لا يمكن التراجع عن هذا الإجراء. سيتم حذف الحجز نهائياً.',
    confirm: 'تأكيد',
    markSeated: 'تسجيل الجلوس',
    markCompleted: 'تسجيل الاكتمال',
    markNoShow: 'تسجيل عدم الحضور',
    cancel: 'إلغاء',
    statusUpdated: 'تم تحديث الحالة',
    statusPending: 'في الانتظار',
    statusConfirmed: 'تم تأكيد الحجز',
    statusSeated: 'تم جلوس الضيف',
    statusCompleted: 'اكتمل الحجز',
    statusCancelled: 'تم إلغاء الحجز',
    statusNoShow: 'لم يحضر',
    status: {
      pending: 'قيد الانتظار',
      confirmed: 'مؤكد',
      seated: 'جالس',
      completed: 'مكتمل',
      cancelled: 'ملغي',
      noShow: 'لم يحضر'
    },
    stats: {
      total: 'الإجمالي',
      pending: 'قيد الانتظار',
      confirmed: 'مؤكد',
      seated: 'جالس',
      completed: 'مكتمل',
      cancelledNoShow: 'ملغي/لم يحضر'
    },
    // Branch selector and booking link
    publicBookingLink: 'رابط الحجز العام',
    shareWithCustomers: 'شارك هذا الرابط مع الزبائن ليتمكنوا من حجز الطاولات عبر الإنترنت',
    linkCopied: 'تم نسخ الرابط',
    linkCopiedDescription: 'تم نسخ رابط الحجز العام',
    // Table selection
    selectTable: 'اختر طاولة',
    noTablePreference: 'بدون تفضيل',
    tableCapacityNote: 'عرض الطاولات التي تتسع لـ {{count}} أشخاص أو أكثر'
  },
  publicReservation: {
    title: 'احجز طاولة',
    subtitle: 'أدخل بياناتك لإجراء الحجز',
    notFound: 'المطعم غير موجود',
    notFoundDescription: 'المطعم الذي تبحث عنه غير موجود أو لم يعد يقبل الحجوزات.',
    success: 'تم إرسال الحجز!',
    successSubtitle: 'سنؤكد حجزك قريباً',
    successDescription: 'تم استلام طلب حجزك. سنقوم بتأكيده قريباً.',
    confirmationNote: 'ستتلقى تأكيداً عبر الهاتف أو البريد الإلكتروني بمجرد الموافقة على حجزك.',
    preferredTable: 'الطاولة المفضلة',
    anyTable: 'أي طاولة متاحة',
    seatsCount: '{{count}} مقاعد',
    error: 'فشل إرسال الحجز. يرجى المحاولة مرة أخرى.',
    submit: 'احجز الطاولة',
    footer: 'مدعوم من Ripplefy',
    location: 'الموقع',
    // Branch selection
    selectBranch: 'اختر الفرع',
    chooseBranchDescription: 'اختر الفرع الذي تريد زيارته',
    // New step-based booking keys
    howManyGuests: 'كم عدد الضيوف؟',
    selectPartySize: 'اختر عدد الأشخاص في مجموعتك',
    selectDate: 'اختر التاريخ',
    forGuests: 'لـ {{count}} ضيوف',
    selectTime: 'اختر الوقت',
    selectTable: 'اختر طاولة',
    tableOptional: 'اختياري - أو دعنا نختار لك',
    letUsChoose: 'دعنا نختار لك أفضل طاولة',
    yourDetails: 'بياناتك',
    howToReachYou: 'كيف يمكننا التواصل معك؟',
    reviewBooking: 'مراجعة الحجز',
    confirmBooking: 'تأكيد الحجز',
    reviewDetails: 'راجع تفاصيل حجزك',
    table: 'الطاولة',
    confirmAndBook: 'تأكيد وحجز'
  },
  security: {
    twoFactor: {
      title: 'المصادقة الثنائية',
      description: 'حماية حسابك بطبقة أمان إضافية باستخدام تطبيق المصادقة',
      upgradeDescription: 'أضف طبقة حماية إضافية لحسابك عبر المصادقة الثنائية',
      upgradePrompt: 'المصادقة الثنائية متاحة في الباقات الاحترافية والمؤسسات. قم بالترقية لتفعيل هذه الميزة الأمنية.',
      notSetup: 'المصادقة الثنائية غير مفعلة حالياً. ننصحك بتفعيلها لحماية أفضل.',
      setupInfo: 'ستحتاج إلى تطبيق مصادقة مثل Google Authenticator أو Authy أو 1Password لإعداد المصادقة الثنائية.',
      setupButton: 'إعداد المصادقة الثنائية',
      enabled: 'المصادقة الثنائية مفعلة',
      enrolledDevices: 'الأجهزة المسجلة',
      authenticatorApp: 'تطبيق المصادقة',
      addedOn: 'أضيف في',
      recommendation: 'ننصح بالإبقاء على المصادقة الثنائية مفعلة وإعداد تطبيق احتياطي على جهاز آخر.',
      setupTitle: 'إعداد المصادقة الثنائية',
      setupSteps: 'امسح رمز QR بتطبيق المصادقة، ثم أدخل رمز التحقق',
      cantScan: 'لا تستطيع المسح؟ أدخل هذا الرمز يدوياً:',
      enterCode: 'أدخل رمز التحقق',
      disableTitle: 'إلغاء المصادقة الثنائية؟',
      disableWarning: 'سيؤدي هذا إلى إزالة طبقة الأمان الإضافية من حسابك. هل أنت متأكد من المتابعة؟',
      disableRisk: 'إلغاء المصادقة الثنائية يجعل حسابك أكثر عرضة للاختراق. ننصح بشدة بإبقائها مفعلة.',
      disableButton: 'إلغاء المصادقة الثنائية'
    },
    changePassword: {
      title: 'تغيير كلمة المرور',
      description: 'حدّث كلمة المرور للحفاظ على أمان حسابك'
    },
    accountSecurity: {
      title: 'أمان الحساب',
      description: 'إدارة إعدادات أمان الحساب',
      tip: 'حافظ على أمان حسابك باستخدام كلمة مرور قوية وتسجيل الخروج من الأجهزة التي لم تعد تستخدمها.'
    },
    signOutAll: 'تسجيل الخروج من جميع الأجهزة',
    signOutAllDescription: 'سيتم تسجيل خروجك من جميع الأجهزة باستثناء هذا الجهاز. ستحتاج لتسجيل الدخول مجدداً على الأجهزة الأخرى.'
  },
  settings: {
    title: 'الإعدادات',
    description: 'إدارة حسابك وتفضيلات التطبيق',
    tabs: {
      usage: 'الاستخدام',
      profile: 'الملف الشخصي',
      notifications: 'الإشعارات',
      security: 'الأمان',
      delivery_zones: 'مناطق التوصيل',
      printers: 'الطابعات',
      general: 'عام'
    },
    no_active_branch: 'لا يوجد فرع نشط',
    create_branch_for_delivery: 'يرجى إنشاء وتفعيل فرع أولاً لإدارة مناطق التوصيل.',
    create_branch_for_printers: 'يرجى إنشاء وتفعيل فرع أولاً لإعداد الطابعات.'
  },
  common: {
    loading: 'جاري التحميل...',
    upgrade_now: 'ترقية الآن',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    remove: 'إزالة',
    edit: 'تعديل',
    add: 'إضافة',
    view: 'عرض',
    back: 'رجوع',
    close: 'إغلاق',
    confirm: 'تأكيد',
    apply: 'تطبيق',
    branch: 'الفرع',
    search: 'بحث',
    filter: 'تصفية',
    all: 'الكل',
    none: 'لا شيء',
    yes: 'نعم',
    no: 'لا',
    error: 'خطأ',
    success: 'نجاح',
    warning: 'تحذير',
    info: 'معلومات',
    export: 'تصدير',
    enabled: 'مفعل',
    proPlan: 'احترافي',
    verify: 'تحقق',
    verifying: 'جاري التحقق...',
    sending: 'جاري الإرسال...',
    keepEnabled: 'إبقاء مفعلة',
    disabling: 'جاري الإلغاء...',
    done: 'تم'
  },
  branding: {
    powered_by: 'يعمل بواسطة',
    tagline: 'إدارة المطاعم أصبحت سهلة'
  },
  backgroundJobs: {
    title: 'المهام الخلفية',
    activeJobs: 'المهام النشطة',
    jobHistory: 'السجل',
    noActiveJobs: 'لا توجد مهام نشطة',
    noJobHistory: 'لا يوجد سجل للمهام',
    cancel: 'إلغاء',
    download: 'تحميل',
    started: 'بدأت',
    completed: 'اكتملت',
    failed: 'فشلت',
    pending: 'قيد الانتظار',
    processing: 'قيد التنفيذ',
    cancelled: 'ملغاة',
    jobTypes: {
      pnl_report: 'تقرير الأرباح والخسائر',
      analytics_export: 'تصدير التحليلات',
      order_history_export: 'تصدير سجل الطلبات',
      inventory_report: 'تقرير المخزون',
      customer_export: 'تصدير العملاء',
      menu_export: 'تصدير القائمة',
      sales_report: 'تقرير المبيعات',
      staff_report: 'تقرير الموظفين',
      bulk_import: 'استيراد جماعي'
    },
    analytics: {
      title: 'لوحة التحليلات',
      subtitle: 'نظرة عامة على الأداء',
      totalRevenue: 'إجمالي الإيرادات',
      totalOrders: 'إجمالي الطلبات',
      averageOrderValue: 'متوسط قيمة الطلب',
      completionRate: 'نسبة الإكمال',
      ordersLast30Days: 'الطلبات في آخر 30 يوم',
      perOrderAverage: 'متوسط لكل طلب',
      ofOrdersCompleted: 'من الطلبات مكتملة',
      fromLastPeriod: 'من الفترة السابقة',
      revenueOverTime: 'الإيرادات عبر الزمن',
      revenueDescription: 'الإيرادات اليومية للفترة المحددة',
      topPerformingItems: 'أفضل الأصناف مبيعاً',
      topItemsDescription: 'الأصناف الأكثر مبيعاً حسب الإيرادات في آخر 30 يوم',
      quickInsights: 'نظرة سريعة',
      keyPerformanceIndicators: 'مؤشرات الأداء الرئيسية',
      noRevenueData: 'لا توجد بيانات إيرادات للفترة المحددة',
      noMenuItemData: 'لا توجد بيانات للأصناف',
      noBranchesAvailable: 'لا توجد فروع متاحة',
      noBranchAccessStaff: 'ليس لديك صلاحية الوصول لأي فرع للتحليلات.',
      noBranchAccessOwner: 'الرجاء إنشاء فرع لعرض التحليلات.',
      loadingAnalytics: 'جاري تحميل التحليلات...',
      errorLoadingSummary: 'خطأ في تحميل البيانات',
      week: 'أسبوع',
      month: 'شهر',
      revenue: 'الإيرادات',
      quantitySold: 'الكمية المباعة',
      revenueTrend: 'اتجاه الإيرادات',
      revenueGrowing: 'الإيرادات ترتفع بنسبة',
      revenueDeclining: 'الإيرادات تنخفض بنسبة',
      comparedToPrevious: 'مقارنة بالفترة السابقة.',
      orderCompletion: 'إكمال الطلبات',
      ordersCompletedSuccessfully: 'من الطلبات تم إكمالها بنجاح.',
      // New mobile-optimized keys
      total: 'الإجمالي',
      noData: 'لا توجد بيانات',
      isTopItem: 'الأكثر مبيعاً',
      sold: 'مباع',
      items: 'أصناف',
      filters: 'الفلاتر',
      timePeriod: 'الفترة الزمنية'
    },
    // مزامنة تطبيق سطح المكتب
    sync: {
      connectionStatus: 'الاتصال',
      online: 'متصل',
      offline: 'غير متصل',
      lastSync: 'آخر مزامنة',
      never: 'لم تتم',
      justNow: 'الآن',
      minutesAgo: 'منذ {{count}} دقيقة',
      hoursAgo: 'منذ {{count}} ساعة',
      pendingChanges: 'تغييرات معلقة',
      syncNow: 'مزامنة الآن',
      refreshMenu: 'تحديث القائمة',
      updateAvailable: 'تحديث متاح',
      downloading: 'جاري التحميل...',
      downloadUpdate: 'تحميل التحديث',
      installUpdate: 'تثبيت وإعادة تشغيل',
      syncError: 'خطأ في المزامنة',
      syncComplete: 'تمت المزامنة',
      syncedItems: 'تم مزامنة {{count}} عنصر',
      failedItems: 'فشل {{count}} عنصر',
      retrying: 'جاري المحاولة...'
    },
    offline: {
      youAreOffline: 'أنت غير متصل بالإنترنت',
      desktopMode: '— وضع سطح المكتب نشط',
      pendingSync: '{{count}} تغييرات بانتظار المزامنة',
      pendingChanges: '{{count}} بانتظار',
      syncing: 'جاري المزامنة...',
      synced: 'تمت المزامنة!',
      syncNow: 'مزامنة الآن',
      offline: 'غير متصل',
      poorConnection: 'اتصال ضعيف',
      retry_sync: 'إعادة المزامنة',
      menuNotCachedTitle: 'الطلبات بدون اتصال تحتاج قائمة مخزنة',
      menuNotCachedDescription: 'اتصل بالإنترنت وخزّن التصنيفات والأصناف لهذا الفرع قبل إنشاء طلبات بدون اتصال.',
      menuNotCachedAction: 'تخزين القائمة للعمل بدون اتصال',
      menuNotCachedHint: 'اتصل بالإنترنت لتخزين القائمة.',
      menuNotCachedToast: 'القائمة غير مخزنة للاستخدام بدون اتصال. اتصل ثم خزّن القائمة وأعد المحاولة.',
      menuPrefetchSuccessTitle: 'تم تخزين القائمة',
      menuPrefetchSuccess: 'تم حفظ بيانات القائمة للاستخدام بدون اتصال.',
      menuPrefetchErrorTitle: 'تعذر تخزين القائمة',
      menuPrefetchError: 'فشل تخزين القائمة. تحقق من الاتصال وحاول مرة أخرى.',
      prefetching: 'جارٍ التخزين...',
      sync_status: {
        synced: 'تمت المزامنة',
        syncing: 'جاري المزامنة...',
        pending: 'بانتظار المزامنة',
        failed: 'فشلت المزامنة',
        offline: 'أُنشئ بدون اتصال'
      },
      conflict: {
        title: 'تم اكتشاف تعارضات',
        description: 'تم تعديل بعض البيانات محلياً وعلى الخادم. اختر كيفية حل كل تعارض.',
        entity: {
          order: 'طلب',
          order_item: 'صنف طلب',
          category: 'فئة',
          menu_item: 'صنف قائمة'
        },
        local: 'محلي (جهازك)',
        server: 'الخادم (الأحدث)',
        keep_mine: 'احتفظ بنسختي',
        use_server: 'استخدم الخادم',
        keep_all_local: 'احتفظ بالكل محلياً',
        use_all_server: 'استخدم كل الخادم',
        apply_selected: 'تطبيق المحدد'
      }
    },
    menuBuilder: {
    title: 'منشئ القائمة',
    blocks: 'العناصر',
    clickToAdd: 'اضغط للإضافة',
    selectBranch: 'يرجى اختيار فرع لاستخدام منشئ القائمة',
    categories: 'الفئات',
    noCategories: 'لا توجد فئات',
    
    categoryNav: {
      sticky: 'موضع لاصق',
      style: 'النمط',
      pills: 'حبوب (دائري)',
      chips: 'رقائق (مربع)',
      buttons: 'أزرار (بحدود)',
      size: 'الحجم',
      small: 'صغير',
      medium: 'متوسط',
      large: 'كبير',
      iconSize: 'حجم الأيقونة',
      showIcons: 'إظهار الأيقونات',
      showNames: 'إظهار الأسماء',
      scrollToCategory: 'انتقل للفئة',
      backgroundColor: 'لون الخلفية',
      activeColor: 'اللون النشط',
    },
    
    // وصف العناصر
    blockDesc: {
      header: 'شعار المطعم واسمه',
      search: 'شريط البحث في القائمة',
      category: 'عرض فئة مع أصنافها',
      featured: 'تسليط الضوء على أصناف مختارة',
      banner: 'بانر إعلاني أو صورة',
      text: 'نص أو إعلان',
      divider: 'فاصل بين الأقسام',
      spacer: 'مسافة فارغة'
    },
    
    // لوحة العمل
    emptyCanvas: 'ابدأ بناء قائمتك',
    emptyCanvasHint: 'اضغط على عنصر من الأدوات لإضافته هنا',
    noBlocks: 'لا توجد عناصر للمعاينة',
    
    // شريط الأدوات
    mobile: 'جوال',
    tablet: 'تابلت',
    preview: 'معاينة',
    previewHint: 'شاهد كيف سيرى الزبائن القائمة',
    publish: 'نشر',
    published: 'منشور',
    unsaved: 'غير محفوظ',
    unsavedChanges: 'لديك تغييرات غير محفوظة. هل تريد المغادرة؟',
    
    // لوحة الخصائص
    noBlockSelected: 'لم يتم اختيار عنصر',
    selectBlockToEdit: 'اختر عنصر لتعديل خصائصه',
    displayOptions: 'خيارات العرض',
    showOptions: 'إظهار',
    
    // عنصر الرأس
    showLogo: 'إظهار الشعار',
    showName: 'إظهار الاسم',
    logoSize: 'حجم الشعار',
    nameStyle: 'نمط الاسم',
    alignment: 'المحاذاة',
    minimal: 'بسيط',
    bold: 'عريض',
    elegant: 'أنيق',
    withCover: 'مع صورة غلاف',
    logoOnly: 'الشعار فقط',
    simple: 'عادي',
    logoPadding: 'المسافة الداخلية',
    
    // عنصر الفئة
    selectCategory: 'اختر الفئة',
    chooseCategory: 'اختر فئة...',
    displayMode: 'طريقة العرض',
    grid: 'شبكة',
    list: 'قائمة',
    compact: 'مختصر',
    columns: 'الأعمدة',
    maxItems: 'الحد الأقصى (0 = الكل)',
    categoryTitle: 'عنوان الفئة',
    images: 'الصور',
    prices: 'الأسعار',
    descriptions: 'الأوصاف',
    categoryNotFound: 'الفئة غير موجودة',
    noItems: 'لا توجد أصناف في هذه الفئة',
    
    // عنصر المميز
    sectionTitle: 'عنوان القسم',
    titlePlaceholder: 'مثال: أطباق الشيف',
    selectedItems: 'الأصناف المختارة',
    noItemsSelected: 'لم يتم اختيار أصناف',
    addItems: 'إضافة أصناف',
    selectItems: 'اختر الأصناف',
    displayStyle: 'نمط العرض',
    carousel: 'منزلق',
    highlight: 'مميز',
    showBadge: 'إظهار الشارة',
    badgeText: 'نص الشارة',
    badgePlaceholder: 'مثال: الأكثر طلباً',
    
    // عنصر البانر
    imageUrl: 'رابط الصورة',
    imageUrlHint: 'استخدم رابط مباشر للصورة',
    subtitle: 'العنوان الفرعي',
    subtitlePlaceholder: 'عنوان فرعي اختياري...',
    bannerTitlePlaceholder: 'عنوان البانر...',
    backgroundColor: 'لون الخلفية',
    height: 'الارتفاع',
    overlayOpacity: 'شفافية الغطاء',
    configureBanner: 'اضبط البانر من الخصائص',
    
    // عنصر النص
    content: 'المحتوى',
    textPlaceholder: 'اكتب النص هنا...',
    textStyle: 'نمط النص',
    body: 'عادي',
    heading: 'عنوان',
    caption: 'تعليق',
    quote: 'اقتباس',
    enterText: 'اكتب النص في الخصائص',
    
    // عنصر الفاصل
    dividerStyle: 'نمط الفاصل',
    line: 'خط',
    dots: 'نقاط',
    icon: 'أيقونة',
    color: 'اللون',
    defaultColor: 'افتراضي',
    
    // عنصر المسافة
    spacerHeight: 'ارتفاع المسافة',
    
    // عنصر البحث
    placeholder: 'نص التلميح',
    searchPlaceholder: 'ابحث في القائمة...',
    searchStyle: 'نمط البحث',
    rounded: 'دائري',
    square: 'مربع',
    
    // عام
    layoutMode: 'طريقة العرض',
    itemShape: 'شكل الصنف',
    fontSize: 'حجم الخط',
    textColor: 'لون النص',
    titleStyling: 'تنسيق العنوان',
    customSizePx: 'حجم مخصص (بكسل)',
    default: 'افتراضي',
    itemTextColors: 'ألوان نصوص الأصناف',
    itemNameColor: 'لون اسم الصنف',
    itemDescriptionColor: 'لون الوصف',
    itemPriceColor: 'لون السعر',
    
    // الأحجام
    sizes: {
      sm: 'صغير',
      md: 'متوسط',
      lg: 'كبير',
      xl: 'كبير جداً',
      '2xl': 'ضخم',
      custom: 'مخصص'
    },
    
    // الأشكال
    shapes: {
      rounded: 'دائري',
      square: 'مربع',
      pill: 'حبة',
      leaf: 'ورقة',
      arch: 'قوس'
    },
    
    // المحاذاة
    align: {
      left: 'يسار',
      center: 'وسط',
      right: 'يمين'
    },
    
    // للتوافق مع الإصدارات السابقة
    toolbox: {
      title: 'صندوق الأدوات',
      subtitle: 'اسحب العناصر إلى اللوحة',
      header: 'رأس الصفحة',
      category: 'فئة',
      carousel: 'عرض منزلق',
      banner: 'بانر',
      textBlock: 'نص',
      searchBar: 'شريط البحث',
      spacer: 'مسافة'
    },
    properties: {
      globalSettings: 'الإعدادات العامة',
      selectCategory: 'اختر الفئة',
      chooseCategory: 'اختر فئة',
      showTitle: 'إظهار العنوان',
      showImages: 'إظهار الصور',
      itemsVisibility: 'إظهار الأصناف',
      noItems: 'لا توجد أصناف في هذه الفئة',
      itemReordering: 'ترتيب الأصناف',
      itemReorderingTip: 'لإعادة ترتيب الأصناف، استخدم وضع "تعديل الأصناف" على البلوك مباشرة.'
    },
    canvas: {
      dragHere: 'اسحب العناصر هنا',
      selectCategoryPrompt: 'اختر فئة من الإعدادات'
    },
    actions: {
      save: 'حفظ',
      saving: 'جاري الحفظ...',
      unsavedChanges: 'تغييرات غير محفوظة',
      savedSuccessfully: 'تم حفظ تصميم القائمة',
      saveFailed: 'فشل حفظ تصميم القائمة'
    },
    alerts: {
      selectBranch: 'يرجى اختيار فرع من القائمة العلوية لاستخدام منشئ القائمة.'
    }
  },
  
    // مصمم القائمة (شبيه فيجما)
    menuDesigner: {
      title: 'مصمم القائمة',
      selectBranch: 'يرجى اختيار فرع لاستخدام مصمم القائمة.',
      import: 'استيراد',
      export: 'تصدير',
      saving: 'جاري الحفظ...',
      save: {
        button: 'حفظ',
        success: 'تم حفظ التصميم',
        successDescription: 'تم حفظ تصميم القائمة بنجاح.',
        error: 'فشل حفظ التصميم'
      },
      tools: {
        select: 'تحديد',
        pan: 'تحريك',
        text: 'نص',
        rectangle: 'مستطيل',
        circle: 'دائرة',
        line: 'خط',
        image: 'صورة',
        menuItem: 'صنف'
      },
      actions: {
        undo: 'تراجع',
        redo: 'إعادة',
        zoomIn: 'تكبير',
        zoomOut: 'تصغير',
        fitToScreen: 'ملء الشاشة'
      },
      view: {
        grid: 'الشبكة',
        rulers: 'المساطر',
        layers: 'الطبقات',
        properties: 'الخصائص'
      },
      layers: {
        title: 'الطبقات',
        empty: 'لا توجد عناصر بعد. أضف عناصر من شريط الأدوات.',
        elements: 'عنصر'
      },
      properties: {
        title: 'الخصائص',
        noSelection: 'اختر عنصر لتعديل خصائصه.',
        design: 'التصميم',
        position: 'الموقع',
        size: 'الحجم',
        rotation: 'الدوران',
        opacity: 'الشفافية',
        text: 'النص',
        font: 'الخط',
        fontSize: 'حجم الخط',
        style: 'النمط',
        color: 'اللون',
        fill: 'التعبئة',
        stroke: 'الحد',
        strokeWidth: 'سمك الحد',
        borderRadius: 'انحناء الحواف',
        imageUrl: 'رابط الصورة',
        fit: 'طريقة العرض',
        variant: 'النوع',
        backgroundColor: 'لون الخلفية',
        priceColor: 'لون السعر'
      },
      assets: {
        title: 'المحتوى',
        subtitle: 'اسحب العناصر لتخصيص قائمتك',
        items: 'الأصناف',
        headers: 'الرؤوس',
        bg: 'الخلفية',
        categories: 'الفئات',
        images: 'الوسائط',
        noItems: 'لا توجد أصناف',
        noCategories: 'لا توجد فئات',
        itemsHelp: 'انقر على الأصناف لإضافتها. وسّع لعناصر منفصلة.',
        categoriesHelp: 'انقر لإضافة عنوان فئة للتصميم',
        uploadImage: 'رفع صورة',
        clickToUpload: 'انقر للرفع',
        imageUrl: 'رابط الصورة',
        quickAdd: 'إضافة سريعة',
        addTitle: 'عنوان',
        addText: 'نص',
        addBorder: 'إطار',
        addDivider: 'فاصل',
        addBox: 'مربع',
        addElement: 'أضف عنصر منفصل:',
        fullCard: 'البطاقة كاملة',
        nameOnly: 'الاسم',
        priceOnly: 'السعر',
        descOnly: 'الوصف',
        imageOnly: 'الصورة فقط',
        restaurantLogo: 'شعار المطعم',
        uploadLogo: 'ارفع الشعار',
        headerElements: 'عناصر الرأس',
        restaurantName: 'اسم المطعم',
        menuTitle: 'قائمتنا',
        tagline: 'طعام لذيذ، مصنوع بحب',
        addRestaurantName: 'اسم المطعم',
        addMenuTitle: 'عنوان القائمة',
        addTagline: 'شعار / عبارة',
        categoryHeaders: 'عناوين الفئات'
      },
      background: {
        title: 'الخلفية',
        color: 'لون',
        gradient: 'تدرج',
        image: 'صورة',
        gradientHint: 'انقر لتطبيق التدرج',
        uploadHint: 'انقر لرفع صورة خلفية',
        patterns: 'أنماط',
        preview: 'الخلفية الحالية',
        currentImage: 'الصورة الحالية'
      }
    }
  }
};